<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title-custom">Chi tiết công việc</div>
        <div class="button-container">
            <Button v-if="$store.getters.type=='company' && $store.getters.controllers?.list_sra && $store.getters.controllers.list_sra.includes('send_contractor')" label="Gửi nhà thầu" @click="GuiNhaThau()" class=""/>
            <Button v-if="$store.getters.typeCompany=='contractor' && $store.getters.roleCompany=='admin'" label="Gửi chủ đầu tư" @click="GuiChuDauTu()" class=""/>
        </div>
        <div>
            <div class="tab">
                <div :class="{ active: currentTab == 0 }" @click="showContent(0)">{{name_tab[0]}}</div>
                <div v-if="show_action" :class="{ active: currentTab == 1 , 'hide-tab' : hideTab == 1}" @click="showContent(1)">{{name_tab[1]}}</div>
                <div v-else :class="{ active: currentTab == 5 , 'hide-tab' : hideTab == 1}" @click="showContent(5)">{{name_tab[1]}}</div>
                <div v-if="show_action && company_type=='option_1'" :class="{ active: currentTab == 11 , 'hide-tab' : hideTab == 1}" @click="showContent(11)">{{name_tab[2]}}</div>
                <div v-else-if="company_type=='option_1'" :class="{ active: currentTab == 12 , 'hide-tab' : hideTab == 1}" @click="showContent(12)">{{name_tab[2]}}</div>
                <div v-else-if="show_action" :class="{ active: currentTab == 2 , 'hide-tab' : hideTab == 1}" @click="showContent(2)">{{name_tab[2]}}</div>
                <div v-else :class="{ active: currentTab == 6 , 'hide-tab' : hideTab == 1}" @click="showContent(6)">{{name_tab[2]}}</div>
                <div v-if="show_action" :class="{ active: currentTab == 3 , 'hide-tab' : hideTab == 1}" @click="showContent(3)">{{name_tab[3]}}</div>
                <div v-else :class="{ active: currentTab == 7 , 'hide-tab' : hideTab == 1}" @click="showContent(7)">{{name_tab[3]}}</div>
                <div v-if="show_action" :class="{ active: currentTab == 4 , 'hide-tab' : hideTab == 1}" @click="showContent(4)">{{name_tab[4]}}</div>
                <div v-else :class="{ active: currentTab == 8 , 'hide-tab' : hideTab == 1}" @click="showContent(8)">{{name_tab[4]}}</div>
                <div v-if="show_action  && company_type=='option_1'" :class="{ active: currentTab == 9 , 'hide-tab' : hideTab == 1}" @click="showContent(9)">{{name_tab[5]}}</div>
                <div v-else-if="company_type=='option_1'" :class="{ active: currentTab == 10 , 'hide-tab' : hideTab == 1}" @click="showContent(10)">{{name_tab[5]}}</div>
                <div v-if="show_danhgia" :class="{ active: currentTab == 13 , 'hide-tab' : hideTab == 1}" @click="showContent(13)">{{name_tab[6]}}</div>
            </div>
            <div :class="{ content : true, active: currentTab == 0 }">
                <div class="button-container">
                    <Button label="Quay lại danh sách" @click="backToList()" class="p-button-warning return-style-button" />
                    <Button v-if="show_cancel==true" label="Hủy bỏ" @click="showCancel()" class="p-button-disa" />
                    <Button v-if="show_edit==true" label="Chỉnh sửa" @click="goEdit()" class="" />
                    <Button v-if="show_approved==true" label="Duyệt SRA này" @click="showApproved()" class="" />
                    <!-- Đổi nút đóng trỏ sang đánh giá -->
                    <!-- <Button v-if="status=='APPROVED' && $store.getters.typeCompany!=='contractor'" label="Đóng SRA" @click="showClose()" class="p-button-disa" /> -->
                     <Button v-if="status=='APPROVED' && $store.getters.typeCompany!=='contractor'" label="Đóng công việc" @click="goEvaluate()" class="p-button-disa" />
                    <!-- Do không còn ATW nữa-->
                    <!-- <Button v-if="status=='APPROVED' && $store.getters.typeCompany!=='contractor' && atw_id==null" label="Cấp giấy phép làm việc (ATW)" @click="goCapGiayPhep()" class="" /> -->
                </div>
                <div class="">
                    <span class="f-cus">{{name}}</span>
                </div>
                <div class="" style="padding-top:8px;">
                    <div class="accordion-item">
                        <label @click="toggleIcon(1)" style="margin:0px;" class="accordion-label">
                            <i style="width : 25px;" :class="show_1 == true ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                            <span>Thông tin chung</span>
                        </label>
                        <div class="accordion-content" v-show="show_1 == true">
                            <div class="f-grid-v">
                                <div class="f-grid-col-v">
                                    <div class="container-tpl">
                                        <div class="left-cs">Công ty</div>
                                        <div class="right-cs">{{company?.name}}</div>
                                    </div>
                                    <div class="container-tpl">
                                        <div class="left-cs">Nhà máy</div>
                                        <div class="right-cs">{{factory?.name}}</div>
                                    </div>
                                    <div class="container-tpl">
                                        <div class="left-cs">Khu vực làm việc</div>
                                        <div class="right-cs">{{areas_text}}</div>
                                    </div>
                                    <div class="container-tpl">
                                        <div class="left-cs">Thời gian thực hiện</div>
                                        <div class="right-cs">{{data_date_text}}</div>
                                    </div>
                                    <div class="container-tpl" v-if="company_type == 'option_1' && show_update_execution_time && status !== 'CLOSE' && status !== 'CANCEL'">
                                        <div class="left-cs"></div>
                                        <div class="right-cs">
                                            <Button label="Cập nhật thời gian thực hiện" @click="showUpdateExecutionTime()" class="" />
                                        </div>
                                    </div>
                                    <div class="container-tpl">
                                        <div class="left-cs">Mức độ</div>
                                        <div class="right-cs" v-html="risk_level_html"></div>
                                    </div>
                                    <div class="container-tpl">
                                        <div class="left-cs">Trạng thái phê duyệt</div>
                                        <div class="right-cs">
                                            <span v-html="status_text"></span>
                                            <span v-if="status=='REJECTED'" @click="viewNote()" style="color:#007bff;text-decoration: underline;cursor: pointer;padding-left: 4px;">Xem lý do</span>
                                        </div>
                                    </div>
                                    <div class="container-tpl">
                                        <div class="left-cs">Trạng thái công việc</div>
                                        <div class="right-cs">
                                            <Dropdown v-model="status_work" :options="status_works" optionLabel="label" style="width: 125px;" :disabled="check_updated==false"/>
                                            <Button v-if="check_updated==true" label="Cập nhật" @click="updateStatusWork()" class="" style="margin-top:2px"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="f-grid-col-v">
                                    <div class="container-tpl">
                                        <div class="left-cs-2">Duyệt cấp 1</div>
                                        <div class="right-cs">{{fullname_c1}}</div>
                                    </div>
                                    <div class="container-tpl">
                                        <div class="left-cs-2">Duyệt cấp 2</div>
                                        <div class="right-cs">{{fullname_c2}}</div>
                                    </div>
                                    <div class="container-tpl">
                                        <div class="left-cs-2">Giám sát</div>
                                        <div class="right-cs">{{supervisor_text}}</div>
                                    </div>
                                    <div class="container-tpl">
                                        <div class="left-cs-2">Nhà thầu</div>
                                        <div class="right-cs" v-html="contractor_html"></div>
                                    </div>
                                    <div class="container-tpl">
                                        <div class="left-cs-2">Khu vực</div>
                                        <div class="right-cs" v-html="zone_html"></div>
                                    </div>
                                    <div v-if="company_type=='option_1'" class="container-tpl">
                                        <div class="left-cs-2">Yêu cầu ngiêm ngặt</div>
                                        <div v-if="request_nv" class="right-cs">Có</div>
                                        <div v-else class="right-cs">Không</div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-content">
                                <div class="f-grid-col-v2">
                                    <div class="container-tpl-v2">
                                        <div class="titel-cs">Mô tả công việc</div>
                                        <div class="" v-html="description"></div>
                                        <hr>
                                        <div class="titel-cs">Những mối nguy liên quan</div>
                                        <div class="" v-for="(item, index) in danger_text" :key="index">- {{item}}</div>
                                        <hr>
                                        <div class="titel-cs">Các biện pháp kiểm soát đề nghị</div>
                                        <div class="" v-html="control_measures_text"></div>
                                        <div class="mt-2">
                                            <div class="titel-cs">File đính kèm</div>
                                            <div class="box-images text-box profile-file-list" v-if="files_control_measures && files_control_measures.length > 0">
                                                <div class="profile-file-row" v-for="(item, index) in files_control_measures" :key="index">
                                                    <a href="#" class="profile-file-link" @click.prevent="viewFile(item)">{{item.name}}</a>
                                                    <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFiles([item])"/>
                                                    <span v-if="item.created_at" style="padding-left: 3px;padding-right: 3px;">{{ item.created_at ? formatDateFile(item.created_at) : '' }}</span>
                                                </div>
                                            </div>
                                            <Button v-if="company_type == 'option_1' && status !== 'CLOSE' && status !== 'CANCEL'" label="Thêm file" icon="pi pi-plus" class="button-box p-button-add mt-2 btn-add-control-measures-file" @click="showAddControlMeasuresFile()"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                </div>
                <div class="" style="padding-top:8px;">
                    <div class="accordion-item">
                        <label @click="toggleIcon(2)" style="margin:0px;" class="accordion-label">
                            <i style="width : 25px;" :class="show_2 == true ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                            <span>Yêu cầu với nhà thầu</span>
                        </label>
                        <div class="accordion-content" v-show="show_2 == true">
                            <div class="accordion-content">
                                <div class="f-grid-col-v2">
                                    <div class="container-tpl-v2">
                                        <table id="yc_nhathau">
                                            <tr>
                                                <th>Hồ sơ doanh nghiệp</th>
                                                <th>Hồ sơ nhân viên</th>
                                                <th>Danh sách các khóa đào tạo</th>
                                                <th>Thiết bị</th>
                                                <th>Vật tư</th>
                                            </tr>
                                            <tr>
                                                <td><div v-html='yc_doanhnghiep'></div></td>
                                                <td><div v-html='yc_nhansu'></div></td>
                                                <td><div v-html='yc_kdt'></div></td>
                                                <td><div v-html='yc_thietbi'></div></td>
                                                <td><div v-html='yc_vattu'></div></td>
                                            </tr>
                                        </table>
                                        <div class="mt-2" v-if="company_type == 'option_1'">
                                            <div class="titel-cs">Giấy phép làm việc</div>
                                            <div class="box-images text-box profile-file-list" v-if="files_work_permit && files_work_permit.length > 0">
                                                <div class="profile-file-row" v-for="(item, index) in files_work_permit" :key="index">
                                                    <a href="#" class="profile-file-link" @click.prevent="viewFile(item)">{{item.name}}</a>
                                                    <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFiles([item])"/>
                                                    <span v-if="item.created_at" style="padding-left: 3px;padding-right: 3px;">{{ item.created_at ? formatDateFile(item.created_at) : '' }}</span>
                                                </div>
                                            </div>
                                            <Button v-if="status !== 'CLOSE' && status !== 'CANCEL'" label="Thêm file" icon="pi pi-plus" class="button-box p-button-add mt-2 btn-add-control-measures-file" @click="showAddWorkPermitFile()"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 1 }">
                <div v-if="status == 'APPROVED'" class="">
                    <table id="yc_nhathau_tab">
                        <tr>
                            <th style="width:35px;">STT</th>
                            <th>Tên hồ sơ</th>
                            <th style="width:260px;">Hồ sơ</th>
                            <th style="width:140px;">Trạng thái</th>
                            <th style="width:140px;">Người cập nhật</th>
                            <th style="width:160px;">Cập nhật cuối</th>
                            <th style="width:120px;text-align: center !important;">
                                <Button @click="goPageAdd('contractor')" icon="pi pi-plus" class="button-box p-button-add"></Button>
                            </th>
                        </tr>
                        <tr v-for="(item, index) in list_tab_yc_contractor" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{item.name}}</td>
                            <td>
                                <div v-if="item.status !== 'NEEDS_UPDATE'" class="profile-file-list">
                                    <div v-for="(file, fileIndex) in item.list_file" :key="fileIndex" class="profile-file-row">
                                        <a href="#" class="profile-file-link" @click.prevent="viewFile(file)">{{file.name}}</a>
                                        <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFiles([file])"/>
                                    </div>
                                </div>
                                <div v-else></div>
                            </td>
                            <td v-html="item.status_html"></td>
                            <td>{{item.updated_fullname}}</td>
                            <td>{{item.time}}</td>
                            <td style="text-align: center !important;">
                                <Button v-if="company_type == 'option_1'" @click="goPageEdit('contractor')" icon="pi pi-pencil" class="button-box p-button-edit"></Button>
                                <Button v-else-if="item.show_edit_contractor==true" @click="goPageEdit('contractor')" icon="pi pi-pencil" class="button-box p-button-edit"></Button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 2 }">
                <div class="button-container" style="margin-bottom: 6px;">
                    <Button label="Xuất file excel" :loading="exporting_excel" :disabled="exporting_excel" @click="exportExcelNhanSu()" class="" />
                    <template v-if="$store.getters.typeCompany!=='contractor'">
                        <Button label="Cấp giấy ra vào cổng" @click="capGiayEP()" class="" />
                        <Button v-if="show_vpat" label="Vi phạm an toàn" @click="ViPhamAnToan()" class="" />
                    </template>
                </div>
                <div v-if="status == 'APPROVED'" class="table-scroll-x" v-drag-scroll>
                    <table id="yc_nhansu_tab">
                        <tr>
                            <th style="width:30px;" v-if="$store.getters.typeCompany!=='contractor'">
                                <Checkbox v-model="check_all" :binary="true" @change="changeSelectRowAll()"/>
                            </th>
                            <th style="width:35px;">STT</th>
                            <th>Username</th>
                            <th>Tên hiển thị</th>
                            <th>Công việc</th>
                            <th style="width:80px;">Duyệt/TC/YCầu</th>
                            <th style="width:105px;">Trạng thái hồ sơ</th>
                            <th style="width:70px;">Khóa học</th>
                            <th style="width:100px;">Giấy vào cổng</th>
                            <th style="">Vi phạm an toàn</th>
                            <th style="">Số lần vi phạm</th>
                            <th style="">Số lần TNLĐ/SCAT</th>
                            <th style="width:105px;">Người cập nhật</th>
                            <th style="width:120px;">Cập nhật cuối</th>
                            <th style="width:90px;text-align: center !important;">
                                <Button @click="goPageAdd('user')" icon="pi pi-plus" class="button-box p-button-add"></Button>
                            </th>
                        </tr>
                        <tr v-for="(item, index) in list_tab_yc_nhansu" :key="index">
                            <td v-if="$store.getters.typeCompany!=='contractor'">
                                <Checkbox v-model="item.active_check" :binary="true" @change="changeSelectRow()"/>
                            </td>
                            <td>{{index + 1}}</td>
                            <td>{{item.username}}</td>
                            <td :class="{'text-inactive-user': item.inactive_user}">{{item.fullname}}<span v-if="item.inactive_user" style="font-weight:600;"> (TK không hoạt động)</span></td>
                            <td>{{item.work_position}}</td>
                            <td style="text-align: center;">{{item.d_tc_yc}}</td>
                            <td v-html="item.status_html"></td>
                            <td style="text-align: center;"><span v-if="item.status=='APPROVED'">{{item.course_text}}</span></td>
                            <td>{{item.time_text}}</td>
                            <td v-html="item.violation_status_html"></td>
                            <td style="text-align: center;">
                                <span v-if="item.total_violation > 0" @click="showViolationHistoryDialog(item)" class="span-link">{{item.total_violation}}</span>
                                <span v-else>0</span>
                            </td>
                            <td style="text-align: center;">
                                <span v-if="item.total_incident > 0" @click="showIncidentHistoryDialog(item)" class="span-link">{{item.total_incident}}</span>
                                <span v-else>0</span>
                            </td>
                            <td>{{item.updated_fullname}}</td>
                            <td>{{item.time}}</td>
                            <td style="text-align: center !important;">
                                <Button @click="showDeletedDialogNS(item)" icon="pi pi-trash p-button-icon" class="button-box p-button-danger" style="margin: 1px;"></Button>
                                <Button v-if="company_type == 'option_1'" @click="goPageEdit('user',item)" icon="pi pi-pencil" class="button-box p-button-edit" style="margin: 1px;"></Button>
                                <Button v-else-if="item.show_edit==true || $store.getters.typeCompany !== 'contractor'" @click="goPageEdit('user',item)" icon="pi pi-pencil" class="button-box p-button-edit" style="margin: 1px;"></Button>
                                <Button @click="goPageView('user',item)" icon="pi pi-eye button-icon" class="button-box" style="margin: 1px;"></Button>
                                <Button v-if="item.download_gp==true" @click="DownloadPDF(item)" icon="pi pi-download button-icon" class="button-box p-button-download-sra" style="margin: 1px;"></Button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 3 }">
                <div v-if="status == 'APPROVED'" class="">
                    <table id="kdt_tab">
                        <tr>
                            <th style="width:35px;">STT</th>
                            <th>Khóa đào tạo</th>
                            <th style="width:70px;">Loại</th>
                            <th>Thời gian</th>
                            <th>Địa điểm</th>
                            <th style="width:260px;">Tài liệu khóa học</th>
                            <th style="width:100px;">Nhân sự đạt</th> 
                            <!-- <th style="width:105px;">Người cập nhật</th> -->
                            <th style="width:120px;">Cập nhật cuối</th>
                            <th v-if="$store.getters.typeCompany!=='contractor'" style="width:90px;text-align: center !important;">
                                <Button @click="showAddLessonDialog()" icon="pi pi-plus" class="button-box p-button-add"></Button>
                            </th>
                        </tr>
                        <tr v-for="(item, index) in list_tab_kdt" :key="index">
                            <td>{{index + 1}}</td>
                            <td v-html="item.name_html"></td>
                            <td>{{item.type_text}}</td>
                            <td>{{item.time_text}}</td>
                            <td>{{item.address}}</td>
                            <td>
                                <div class="profile-file-list">
                                    <div v-for="(file, fileIndex) in item.files" :key="fileIndex" class="profile-file-row">
                                        <a href="#" class="profile-file-link" @click.prevent="viewFile(file)">{{file.name}}</a>
                                        <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFiles([file])"/>
                                    </div>
                                </div>
                            </td>
                            <td style="text-align: center;"><span v-if="item.lesson_text" @click="showUpdateLessonUsersDialog(item)" class="span-link">{{item.lesson_text}}</span></td>
                            <!-- <td>Người cập nhật</td> -->
                            <td>{{item.time}}</td>
                            <td v-if="$store.getters.typeCompany!=='contractor'" style="text-align: center !important;">
                                <Button @click="showUpdateLessonDialog(index)" icon="pi pi-pencil" class="button-box p-button-edit" style="margin: 1px;"></Button>
                                <Button @click="showDeletedDialog(index)" icon="pi pi-trash p-button-icon" class="button-box p-button-danger" style="margin: 1px;"></Button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 4 }">
                <div v-if="status == 'APPROVED'" class="">
                    <table id="yc_vattu_thietbi_tab">
                        <tr>
                            <th style="width:35px;">STT</th>
                            <th style="width:80px;">Loại</th>
                            <th style="width:80px;">Ảnh</th>
                            <th>Tên gọi</th>
                            <th style="width:260px;">HS được duyệt</th>
                            <th style="width:105px;">Trạng thái hồ sơ</th>
                            <th style="width:120px;">Người cập nhật</th>
                            <th style="width:120px;">Cập nhật cuối</th>
                            <th style="width:90px;text-align: center !important;">
                                <Button @click="goPageAdd('supplies_equipment')" icon="pi pi-plus" class="button-box p-button-add"></Button>
                            </th>
                        </tr>
                        <tr v-for="(item, index) in list_tab_yc_vttb" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{item.type_text}}</td>
                            <td>
                                <img v-if="item.avatar" :src="item.avatar.url" style="width: 50px; height: 50px"/>
                            </td>
                            <td>{{item.name}}</td>
                            <td style="text-align: center;">
                                <span v-if="$store.getters.typeCompany !== 'contractor'">{{item.d_tc_yc}}</span>
                                <div v-else-if="item.list_file.length > 0" class="profile-file-list">
                                    <div v-for="(file, fileIndex) in item.list_file" :key="fileIndex" class="profile-file-row">
                                        <a href="#" class="profile-file-link" @click.prevent="viewFile(file)">{{file.name}}</a>
                                        <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFiles([file])"/>
                                    </div>
                                </div>
                            </td>
                            <td v-html="item.status_html"></td>
                            <td>{{item.updated_fullname}}</td>
                            <td>{{item.time}}</td>
                            <td style="text-align: center !important;">
                                <Button @click="showDeletedDialogVTTB(item)" icon="pi pi-trash p-button-icon" class="button-box p-button-danger" style="margin: 1px;"></Button>
                                <Button v-if="company_type == 'option_1'" @click="goPageEdit('supplies_equipment',item)" icon="pi pi-pencil" class="button-box p-button-edit" style="margin: 1px;"></Button>
                                <Button v-else-if="item.show_edit==true || $store.getters.typeCompany !== 'contractor'" @click="goPageEdit('supplies_equipment',item)" icon="pi pi-pencil" class="button-box p-button-edit" style="margin: 1px;"></Button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 5 }">
                <div class="">
                    <table id="yc_nhathau_tab">
                        <tr>
                            <th style="width:35px;">STT</th>
                            <th>Tên hồ sơ</th>
                            <th style="width:260px;">Hồ sơ</th>
                            <th style="width:140px;">Trạng thái</th>
                            <th style="width:140px;">Người cập nhật</th>
                            <th style="width:160px;">Cập nhật cuối</th>
                        </tr>
                        <tr v-for="(item, index) in list_tab_yc_contractor" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{item.name}}</td>
                            <td>
                                <div v-if="item.status !== 'NEEDS_UPDATE'" class="profile-file-list">
                                    <div v-for="(file, fileIndex) in item.list_file" :key="fileIndex" class="profile-file-row">
                                        <a href="#" class="profile-file-link" @click.prevent="viewFile(file)">{{file.name}}</a>
                                        <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFiles([file])"/>
                                    </div>
                                </div>
                                <div v-else></div>
                            </td>
                            <td v-html="item.status_html"></td>
                            <td>{{item.updated_fullname}}</td>
                            <td>{{item.time}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 6 }">
                <div class="button-container" style="margin-bottom: 6px;">
                    <Button label="Xuất file excel" :loading="exporting_excel" :disabled="exporting_excel" @click="exportExcelNhanSu()" class="" />
                </div>
                <div class="table-scroll-x" v-drag-scroll>
                    <table id="yc_nhansu_tab">
                        <tr>
                            <th style="width:35px;">STT</th>
                            <th>Username</th>
                            <th>Tên hiển thị</th>
                            <th>Công việc</th>
                            <th style="width:80px;">Duyệt/TC/YCầu</th>
                            <th style="width:105px;">Trạng thái hồ sơ</th>
                            <th style="width:70px;">Khóa học</th>
                            <th style="width:100px;">Giấy vào cổng</th>
                            <th style="">Vi phạm an toàn</th>
                            <th style="">Số lần vi phạm</th>
                            <th style="">Số lần TNLĐ/SCAT</th>
                            <th style="width:105px;">Người cập nhật</th>
                            <th style="width:120px;">Cập nhật cuối</th>
                        </tr>
                        <tr v-for="(item, index) in list_tab_yc_nhansu" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{item.username}}</td>
                            <td :class="{'text-inactive-user': item.inactive_user}">{{item.fullname}}<span v-if="item.inactive_user" style="font-weight:600;"> (TK không hoạt động)</span></td>
                            <td>{{item.work_position}}</td>
                            <td style="text-align: center;">{{item.d_tc_yc}}</td>
                            <td v-html="item.status_html"></td>
                            <td style="text-align: center;"><span v-if="item.status=='APPROVED'">{{item.course_text}}</span></td>
                            <td>{{item.time_text}}</td>
                            <td v-html="item.violation_status_html"></td>
                            <td style="text-align: center;">{{item.total_violation}}</td>
                            <td style="text-align: center;">
                                <span v-if="item.total_incident > 0" @click="showIncidentHistoryDialog(item)" class="span-link">{{item.total_incident}}</span>
                                <span v-else>0</span>
                            </td>
                            <td>{{item.updated_fullname}}</td>
                            <td>{{item.time}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 7 }">
                <div class="">
                    <table id="kdt_tab">
                        <tr>
                            <th style="width:35px;">STT</th>
                            <th>Khóa đào tạo</th>
                            <th style="width:70px;">Loại</th>
                            <th>Thời gian</th>
                            <th>Địa điểm</th>
                            <th style="width:260px;">Tài liệu khóa học</th>
                            <th style="width:100px;">Nhân sự đạt</th> 
                            <!-- <th style="width:105px;">Người cập nhật</th> -->
                            <th style="width:120px;">Cập nhật cuối</th>
                        </tr>
                        <tr v-for="(item, index) in list_tab_kdt" :key="index">
                            <td>{{index + 1}}</td>
                            <td v-html="item.name_html"></td>
                            <td>{{item.type_text}}</td>
                            <td>{{item.time_text}}</td>
                            <td>{{item.address}}</td>
                            <td>
                                <div class="profile-file-list">
                                    <div v-for="(file, fileIndex) in item.files" :key="fileIndex" class="profile-file-row">
                                        <a href="#" class="profile-file-link" @click.prevent="viewFile(file)">{{file.name}}</a>
                                        <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFiles([file])"/>
                                    </div>
                                </div>
                            </td>
                            <td style="text-align: center;"><span v-if="item.lesson_text" class="">{{item.lesson_text}}</span></td>
                            <!-- <td>Người cập nhật</td> -->
                            <td>{{item.time}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            
            <div :class="{ content : true, active: currentTab == 8 }">
                <div class="">
                    <table id="yc_vattu_thietbi_tab">
                        <tr>
                            <th style="width:35px;">STT</th>
                            <th style="width:80px;">Loại</th>
                            <th style="width:80px;">Ảnh</th>
                            <th>Tên gọi</th>
                            <th style="width:260px;">HS được duyệt</th>
                            <th style="width:105px;">Trạng thái hồ sơ</th>
                            <th style="width:120px;">Người cập nhật</th>
                            <th style="width:120px;">Cập nhật cuối</th>
                        </tr>
                        <tr v-for="(item, index) in list_tab_yc_vttb" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{item.type_text}}</td>
                            <td>
                                <img v-if="item.avatar" :src="item.avatar.url" style="width: 50px; height: 50px"/>
                            </td>
                            <td>{{item.name}}</td>
                            <td style="text-align: center;">
                                <span v-if="$store.getters.typeCompany !== 'contractor'">{{item.d_tc_yc}}</span>
                                <div v-else-if="item.list_file.length > 0" class="profile-file-list">
                                    <div v-for="(file, fileIndex) in item.list_file" :key="fileIndex" class="profile-file-row">
                                        <a href="#" class="profile-file-link" @click.prevent="viewFile(file)">{{file.name}}</a>
                                        <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFiles([file])"/>
                                    </div>
                                </div>
                            </td>
                            <td v-html="item.status_html"></td>
                            <td>{{item.updated_fullname}}</td>
                            <td>{{item.time}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 9 }">
                <div class="button-container" style="margin-bottom: 6px; justify-content: space-between; align-items: center;">
                    <span style="font-size: 16px;font-weight: 600;">Số giờ làm việc: {{ sra_total_hour || 0 }} giờ</span>
                    <div style="display: flex; gap: 6px;">
                        <!-- <Button v-if="show_upd_time" label="Cập nhật giờ làm việc" @click="showUpdateTotalHourDialog()" class="p-button-warning" /> -->
                        <Button v-if="show_diemdanh" label="Điểm danh" @click="showAttendanceDialog()" class="" />
                    </div>
                </div>
                <div v-if="status == 'APPROVED'" class="">
                    <DataTable
                        :value="list_tab_diemdanh"
                        :lazy="true"
                        :loading="attendance_loading"
                        class="p-datatable-responsive"
                        responsiveLayout="scroll"
                        :autoLayout="true"
                        :paginator="attendance_pagination.total > 0"
                        @page="onAttendancePage($event)"
                        :totalRecords="attendance_pagination.total"
                        :rows="attendance_pagination.limit"
                        :first="attendance_pagination.offset"
                        :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
                        :currentPageReportTemplate="$constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM + ' {totalRecords}'"
                        :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
                    >
                        <Column header="STT" headerStyle="width: 35px;" bodyStyle="width: 35px;">
                            <template #body="slotProps">
                                {{ attendance_pagination.offset + slotProps.index + 1 }}
                            </template>
                        </Column>
                        <Column field="username" header="Username"></Column>
                        <Column field="fullname" header="Tên hiển thị"></Column>
                        <Column field="work_position" header="Công việc"></Column>
                        <Column field="time_range_text" header="Giờ vào-giờ ra" headerStyle="width: 120px;" bodyStyle="width: 120px; text-align: center;"></Column>
                        <Column field="working_hours_text" header="Số giờ" headerStyle="width: 90px;" bodyStyle="width: 90px; text-align: center;"></Column>
                        <Column field="updated_fullname" header="Người cập nhật" headerStyle="width: 105px;" bodyStyle="width: 105px;"></Column>
                        <Column field="time" header="Cập nhật cuối" headerStyle="width: 120px;" bodyStyle="width: 120px;"></Column>
                        <Column header="Hành động" headerStyle="width: 90px;text-align: center !important;" bodyStyle="width: 90px;text-align: center !important;">
                            <template #body="slotProps">
                                <Button v-if="show_diemdanh_edit" @click="editAttendance(slotProps.data)" icon="pi pi-pencil" class="button-box p-button-edit" style="margin: 1px;"></Button>
                                <Button v-if="show_diemdanh_deleted" @click="showDeleteAttendanceDialog(slotProps.data)" icon="pi pi-trash p-button-icon" class="button-box p-button-danger" style="margin: 1px;"></Button>
                            </template>
                        </Column>
                        <!-- <template #empty>
                            <div class="text-center">{{ $t('datatable.empty') }}</div>
                        </template> -->
                    </DataTable>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 10 }">
                <div class="button-container" style="margin-bottom: 6px; justify-content: space-between; align-items: center;">
                    <span style="font-size: 16px;font-weight: 600;">Tổng số giờ làm việc: {{ sra_total_hour || 0 }} giờ</span>
                    <div style="display: flex; gap: 6px;">
                        <Button v-if="show_upd_time" label="Cập nhật giờ làm việc" @click="showUpdateTotalHourDialog()" class="" />
                        <!-- <Button v-if="show_diemdanh" label="Điểm danh" @click="showAttendanceDialog()" class="" /> -->
                    </div>
                </div>
                <div class="">
                    <DataTable
                        :value="list_tab_diemdanh"
                        :lazy="true"
                        :loading="attendance_loading"
                        class="p-datatable-responsive"
                        responsiveLayout="scroll"
                        :autoLayout="true"
                        :paginator="attendance_pagination.total > 0"
                        @page="onAttendancePage($event)"
                        :totalRecords="attendance_pagination.total"
                        :rows="attendance_pagination.limit"
                        :first="attendance_pagination.offset"
                        :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
                        :currentPageReportTemplate="$constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM + ' {totalRecords}'"
                        :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
                    >
                        <Column header="STT" headerStyle="width: 35px;" bodyStyle="width: 35px;">
                            <template #body="slotProps">
                                {{ attendance_pagination.offset + slotProps.index + 1 }}
                            </template>
                        </Column>
                        <Column field="username" header="Username"></Column>
                        <Column field="fullname" header="Tên hiển thị"></Column>
                        <Column field="work_position" header="Công việc"></Column>
                        <Column field="time_range_text" header="Giờ vào-giờ ra" headerStyle="width: 120px;" bodyStyle="width: 120px; text-align: center;"></Column>
                        <Column field="working_hours_text" header="Số giờ" headerStyle="width: 90px;" bodyStyle="width: 90px; text-align: center;"></Column>
                        <Column field="updated_fullname" header="Người cập nhật" headerStyle="width: 105px;" bodyStyle="width: 105px;"></Column>
                        <Column field="time" header="Cập nhật cuối" headerStyle="width: 120px;" bodyStyle="width: 120px;"></Column>
                        <!-- <template #empty>
                            <div class="text-center">{{ $t('datatable.empty') }}</div>
                        </template> -->
                    </DataTable>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 11 }">
                <div class="button-container" style="margin-bottom: 6px;">
                    <Button label="Xuất file excel" :loading="exporting_excel" :disabled="exporting_excel" @click="exportExcelNhanSu()" class="" />
                    <template v-if="$store.getters.typeCompany!=='contractor'">
                        <Button label="Cấp giấy ra vào cổng" @click="capGiayEP()" class="" />
                        <Button v-if="show_vpat" label="Vi phạm an toàn" @click="ViPhamAnToan()" class="" />
                        <Button v-if="show_scat" label="Loại TNLĐ/Sự cố an toàn" @click="SuCoAnToan()" class="" />
                    </template>
                </div>
                <div v-if="status == 'APPROVED'" class="table-scroll-x" v-drag-scroll>
                    <table id="yc_nhansu_tab">
                        <tr>
                            <th style="width:30px;" v-if="$store.getters.typeCompany!=='contractor'">
                                <Checkbox v-model="check_all" :binary="true" @change="changeSelectRowAll()"/>
                            </th>
                            <th style="width:35px;">STT</th>
                            <th>Username</th>
                            <th>Tên hiển thị</th>
                            <th>Công việc</th>
                            <th style="width:80px;">Duyệt/TC/YCầu</th>
                            <th style="width:105px;">Trạng thái hồ sơ</th>
                            <th style="width:70px;">Tổng số giờ/ngày</th>
                            <th style="width:70px;">Khóa học</th>
                            <th style="width:100px;">Giấy vào cổng</th>
                            <th style="">Vi phạm an toàn</th>
                            <th style="">Số lần vi phạm</th>
                            <th style="">Số lần TNLĐ/SCAT</th>
                            <th style="width:73px;">Điểm danh cuối</th>
                            <th style="width:105px;">Người cập nhật</th>
                            <th style="width:120px;">Cập nhật cuối</th>
                            <th style="width:90px;text-align: center !important;">
                                <Button @click="goPageAdd('user')" icon="pi pi-plus" class="button-box p-button-add"></Button>
                            </th>
                        </tr>
                        <tr v-for="(item, index) in list_tab_yc_nhansu" :key="index">
                            <td v-if="$store.getters.typeCompany!=='contractor'">
                                <Checkbox v-model="item.active_check" :binary="true" @change="changeSelectRow()"/>
                            </td>
                            <td>{{index + 1}}</td>
                            <td>{{item.username}}</td>
                            <td :class="{'text-inactive-user': item.inactive_user}">{{item.fullname}}<span v-if="item.inactive_user" style="font-weight:600;"> (TK không hoạt động)</span></td>
                            <td>{{item.work_position}}</td>
                            <td style="text-align: center;">{{item.d_tc_yc}}</td>
                            <td v-html="item.status_html"></td>
                            <td>{{item.attendance_total_hour}}/{{item.attendance_total_date}}</td>
                            <td style="text-align: center;"><span v-if="item.status=='APPROVED'">{{item.course_text}}</span></td>
                            <td>{{item.time_text}}</td>
                            <td v-html="item.violation_status_html"></td>
                            <td style="text-align: center;">
                                <span v-if="item.total_violation > 0" @click="showViolationHistoryDialog(item)" class="span-link">{{item.total_violation}}</span>
                                <span v-else>0</span>
                            </td>
                            <td style="text-align: center;">
                                <span v-if="item.total_incident > 0" @click="showIncidentHistoryDialog(item)" class="span-link">{{item.total_incident}}</span>
                                <span v-else>0</span>
                            </td>
                            <td>{{item.last_time_attendance}}</td>
                            <td>{{item.updated_fullname}}</td>
                            <td>{{item.time}}</td>
                            <td style="text-align: center !important;">
                                <Button @click="showDeletedDialogNS(item)" icon="pi pi-trash p-button-icon" class="button-box p-button-danger" style="margin: 1px;"></Button>
                                <!-- <Button v-if="item.show_edit==true || $store.getters.typeCompany !== 'contractor'" @click="goPageEdit('user',item)" icon="pi pi-pencil" class="button-box p-button-edit" style="margin: 1px;"></Button> -->
                                <Button @click="goPageEdit('user',item)" icon="pi pi-pencil" class="button-box p-button-edit" style="margin: 1px;"></Button>
                                <Button @click="goPageView('user',item)" icon="pi pi-eye button-icon" class="button-box" style="margin: 1px;"></Button>
                                <Button v-if="item.download_gp==true" @click="DownloadPDF(item)" icon="pi pi-download button-icon" class="button-box p-button-download-sra" style="margin: 1px;"></Button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 12 }">
                <div class="button-container" style="margin-bottom: 6px;">
                    <Button label="Xuất file excel" :loading="exporting_excel" :disabled="exporting_excel" @click="exportExcelNhanSu()" class="" />
                </div>
                <div class="table-scroll-x" v-drag-scroll>
                    <table id="yc_nhansu_tab">
                        <tr>
                            <th style="width:35px;">STT</th>
                            <th>Username</th>
                            <th>Tên hiển thị</th>
                            <th>Công việc</th>
                            <th style="width:80px;">Duyệt/TC/YCầu</th>
                            <th style="width:105px;">Trạng thái hồ sơ</th>
                            <th style="width:70px;">Tổng số giờ/ngày</th>
                            <th style="width:70px;">Khóa học</th>
                            <th style="width:100px;">Giấy vào cổng</th>
                            <th style="">Vi phạm an toàn</th>
                            <th style="">Số lần vi phạm</th>
                            <th style="">Số lần TNLĐ/SCAT</th>
                            <th style="width:73px;">Điểm danh cuối</th>
                            <th style="width:105px;">Người cập nhật</th>
                            <th style="width:120px;">Cập nhật cuối</th>
                        </tr>
                        <tr v-for="(item, index) in list_tab_yc_nhansu" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{item.username}}</td>
                            <td :class="{'text-inactive-user': item.inactive_user}">{{item.fullname}}<span v-if="item.inactive_user" style="font-weight:600;"> (TK không hoạt động)</span></td>
                            <td>{{item.work_position}}</td>
                            <td style="text-align: center;">{{item.d_tc_yc}}</td>
                            <td v-html="item.status_html"></td>
                            <td>{{item.attendance_total_hour}}/{{item.attendance_total_date}}</td>
                            <td style="text-align: center;"><span v-if="item.status=='APPROVED'">{{item.course_text}}</span></td>
                            <td>{{item.time_text}}</td>
                            <td v-html="item.violation_status_html"></td>
                            <td style="text-align: center;">
                                <span v-if="item.total_violation > 0" @click="showViolationHistoryDialog(item)" class="span-link">{{item.total_violation}}</span>
                                <span v-else>0</span>
                            </td>
                            <td style="text-align: center;">
                                <span v-if="item.total_incident > 0" @click="showIncidentHistoryDialog(item)" class="span-link">{{item.total_incident}}</span>
                                <span v-else>0</span>
                            </td>
                            <td>{{item.last_time_attendance}}</td>
                            <td>{{item.updated_fullname}}</td>
                            <td>{{item.time}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div :class="{ content : true, active: currentTab == 13 }">
                <div class="evaluation-view">
                    <div class="f-grid" style="margin: 0px 10px 0px 10px;">
                        <div class="f-grid-col">
                            <div class="mt-2" style="padding-top: 5px;">
                                <label class="txt-right evaluation-title">ĐÁNH GIÁ NHÀ THẦU</label>
                            </div>
                            <div class="mt-2">
                                <label class="txt-right evaluation-label">An toàn</label>
                                <div class="btn-group-css text-box input-text-box readonly-box">
                                    <button
                                        v-for="item in evaluationRateOptions"
                                        :key="`safe-${item.value}`"
                                        type="button"
                                        :class="['btn-switch', { selected: evaluation.safe_value == item.value }]"
                                        disabled
                                    >
                                        {{ item.label }}
                                    </button>
                                </div>
                            </div>
                            <div class="mt-2">
                                <label class="txt-right evaluation-label">Chất lượng dịch vụ</label>
                                <div class="btn-group-css text-box input-text-box readonly-box">
                                    <button
                                        v-for="item in evaluationRateOptions"
                                        :key="`quality-${item.value}`"
                                        type="button"
                                        :class="['btn-switch', { selected: evaluation.quality_value == item.value }]"
                                        disabled
                                    >
                                        {{ item.label }}
                                    </button>
                                </div>
                            </div>
                            <div class="mt-2">
                                <label class="txt-right evaluation-label">Tiếp tục sử dụng cho lần sau</label>
                                <div class="btn-group-css text-box input-text-box readonly-box">
                                    <button
                                        v-for="item in evaluationContinueOptions"
                                        :key="`continue-${item.value}`"
                                        type="button"
                                        :class="['btn-switch', { selected: evaluation.continue_value == item.value }]"
                                        disabled
                                    >
                                        {{ item.label }}
                                    </button>
                                </div>
                            </div>
                            <div class="mt-2">
                                <label class="txt-right evaluation-label">Ghi chú</label>
                                <div class="evaluation-note text-box input-text-box">{{ evaluation.note || '-' }}</div>
                            </div>
                            <div class="mt-2">
                                <label class="txt-right evaluation-label">Xếp hạng</label>
                                <div class="btn-group-css text-box input-text-box readonly-box">
                                    <button
                                        v-for="item in evaluationBadgeOptions"
                                        :key="`badge-${item.value}`"
                                        type="button"
                                        :class="[item.className, { selected: evaluation.badge == item.value }]"
                                        disabled
                                    >
                                        {{ item.label }}
                                    </button>
                                </div>
                            </div>
                            <div class="mt-2" v-if="company_type == 'option_1'">
                                <div class="mt-3">
                                    <label class="txt-right evaluation-label">Loại TNLĐ/Sự cố an toàn</label>
                                    <div class="evaluation-tags text-box input-text-box">
                                        <template v-if="evaluation.incidents.length > 0">
                                            <label
                                                v-for="(item, index) in evaluation.incidents"
                                                :key="`view-incidents-${item.id || index}`"
                                                class="cus-tags-1"
                                            >
                                                <span class="cs-tag-1">{{ item.label }}</span>
                                            </label>
                                        </template>
                                        <span v-else class="evaluation-empty">-</span>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-2" v-if="company_type == 'option_1'">
                                <div class="mt-3">
                                    <label class="txt-right evaluation-label">Vi phạm an toàn</label>
                                    <div class="evaluation-tags text-box input-text-box">
                                        <template v-if="evaluation.violations.length > 0">
                                            <label
                                                v-for="(item, index) in evaluation.violations"
                                                :key="`view-violations-${item.id || index}`"
                                                class="cus-tags-1"
                                            >
                                                <span class="cs-tag-1">{{ item.label }}</span>
                                            </label>
                                        </template>
                                        <span v-else class="evaluation-empty">-</span>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-2">
                                <label class="txt-right evaluation-label">File đính kèm</label>
                                <div class="box-images text-box" v-if="files_evaluate && files_evaluate.length > 0">
                                    <div class="d-flex align-items-center" v-for="(item, index) in files_evaluate" :key="index">
                                    <div class="file-name">{{ item.name }}</div>
                                    <Button icon="pi pi-download" class="p-button-download p-button-link" @click="onFileDownload1(index)"/>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!hasEvaluationData()" class="evaluation-empty-state">
                                Chưa có dữ liệu đánh giá.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
        <Dialog style="" header="Điểm danh" :visible.sync="showAttendanceModal" :contentStyle="{overflow: 'visible'}" :modal="true">
            <div style="width: 400px;">
                <div>
                    <label class="txt-left">Ngày giờ vào</label>
                    <Calendar
                        v-model="attendance_date_start"
                        :showTime="true"
                        :showSeconds="true"
                        hourFormat="24"
                        dateFormat="dd/mm/yy"
                        :showIcon="true"
                        :maxDate="new Date()"
                        :manualInput="false"
                        @input="updateAttendanceCommonHours()"
                    />
                </div>
                <div class="mt-2">
                    <label class="txt-left">Ngày giờ ra</label>
                    <Calendar
                        v-model="attendance_date_end"
                        :showTime="true"
                        :showSeconds="true"
                        hourFormat="24"
                        dateFormat="dd/mm/yy"
                        :showIcon="true"
                        :maxDate="new Date()"
                        :manualInput="false"
                        @input="updateAttendanceCommonHours()"
                    />
                </div>
                <div class="mt-2">
                    <label class="txt-left">Số giờ</label>
                    <InputNumber
                        v-model="attendance_working_hours"
                        :min="0"
                        :minFractionDigits="2"
                        :maxFractionDigits="2"
                        mode="decimal"
                        class="attendance-hours-input"
                    />
                </div>
                <div class="mt-2">
                    <label class="txt-left">Nhân sự</label>
                    <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        width="100%"
                        defaultLabel="fullname"
                        :limit="attendance_users_obj.limit"
                        :loading="attendance_users_obj.loading"
                        v-model="attendance_user_sel"
                        :options="attendance_users_obj.items"
                        :total="attendance_users_obj.total"
                        @keyup="emitEventAttendanceUsers"
                        @scroll="emitEventAttendanceUsers"
                        @offset="changeOffsetAttendanceUsers"
                    />
                </div>
                <div class="mt-2">
                    <label v-for="(item, index) in attendance_users_sel" :key="`attendance-user-${item.uid || item.id}-${index}`" class="cus-tags">
                        <span class="cs-tag">
                            {{item.fullname}}
                        </span>
                        <i class="fas fa-times cs-icon" v-on:click="removeAttendanceUser(index)"></i>
                    </label>
                </div>
            </div>
            <template #footer>
                <Button label="Hủy" @click="showAttendanceModal = false" icon="pi pi-times" class="p-button-disa" />
                <Button label="Xác nhận" @click="saveAttendance()" icon="pi pi-check" class="" />
            </template>
        </Dialog>
        <Dialog style="" header="Sửa điểm danh" :visible.sync="showAttendanceEditModal" :contentStyle="{overflow: 'visible'}" :modal="true">
            <div style="width: 400px;">
                <div>
                    <label class="txt-left">Ngày giờ vào</label>
                    <Calendar
                        v-model="attendance_edit_data.date_start"
                        :showTime="true"
                        :showSeconds="true"
                        hourFormat="24"
                        dateFormat="dd/mm/yy"
                        :showIcon="true"
                        :maxDate="new Date()"
                        :manualInput="false"
                        @input="updateAttendanceEditHours()"
                    />
                </div>
                <div class="mt-2">
                    <label class="txt-left">Ngày giờ ra</label>
                    <Calendar
                        v-model="attendance_edit_data.date_end"
                        :showTime="true"
                        :showSeconds="true"
                        hourFormat="24"
                        dateFormat="dd/mm/yy"
                        :showIcon="true"
                        :maxDate="new Date()"
                        :manualInput="false"
                        @input="updateAttendanceEditHours()"
                    />
                </div>
                <div class="mt-2">
                    <label class="txt-left">Số giờ</label>
                    <InputNumber
                        v-model="attendance_edit_data.working_hours"
                        :min="0"
                        :minFractionDigits="2"
                        :maxFractionDigits="2"
                        mode="decimal"
                        class="attendance-hours-input"
                    />
                </div>
                <div class="mt-2">
                    <label class="txt-left">Nhân sự</label>
                    <InputText
                        :value="attendance_edit_data.fullname"
                        type="text"
                        class="cs-input input-text-box"
                        disabled
                    />
                </div>
            </div>
            <template #footer>
                <Button label="Hủy" @click="showAttendanceEditModal = false" icon="pi pi-times" class="p-button-disa" />
                <Button label="Cập nhật" @click="updateAttendance()" icon="pi pi-check" class="" />
            </template>
        </Dialog>
        <Dialog style="" header="Cập nhật giờ làm việc" :visible.sync="showUpdateTotalHourModal" :contentStyle="{overflow: 'visible'}" :modal="true">
            <div style="width: 400px;">
                <div>
                    <label class="txt-left">Số giờ làm việc</label>
                    <InputNumber
                        v-model="sra_total_hour_input"
                        :min="0"
                        :minFractionDigits="2"
                        :maxFractionDigits="2"
                        mode="decimal"
                        class="attendance-hours-input"
                    />
                </div>
            </div>
            <template #footer>
                <Button label="Hủy" @click="showUpdateTotalHourModal = false" icon="pi pi-times" class="p-button-disa" />
                <Button label="Cập nhật" @click="updateSraTotalHour()" icon="pi pi-check" class="" />
            </template>
        </Dialog>
        <Dialog style="" header="Cập nhật thời gian thực hiện" :visible.sync="showUpdateExecutionTimeModal" :contentStyle="{overflow: 'visible'}" :modal="true">
            <div style="width: 400px;">
                <div>
                    <label class="txt-left required">Thời gian thực hiện từ</label>
                    <Calendar
                        disabled
                        v-model="execution_time_start"
                        dateFormat="dd/mm/yy"
                        :showIcon="true"
                        :manualInput="false"
                    />
                </div>
                <div class="mt-2">
                    <label class="txt-left required">Thời gian thực hiện đến</label>
                    <Calendar
                        v-model="execution_time_end"
                        dateFormat="dd/mm/yy"
                        :showIcon="true"
                        :manualInput="false"
                        :showButtonBar="true"
                    />
                </div>
            </div>
            <template #footer>
                <Button label="Hủy" @click="showUpdateExecutionTimeModal = false" icon="pi pi-times" class="p-button-disa" />
                <Button label="Lưu" @click="saveUpdateExecutionTime()" icon="pi pi-check" class="" />
            </template>
        </Dialog>
        <Dialog style="" header="Xóa" :visible.sync="showDeleteAttendanceDialogModal" :contentStyle="{overflow: 'visible'}" :modal="true">
            Bạn có chắc muốn xóa bản ghi điểm danh này không?
          <template #footer>
            <Button label="Hủy" @click="showDeleteAttendanceDialogModal = false" icon="pi pi-times" class="p-button-disa" />
            <Button label="Xóa" @click="deleteAttendance()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
        <Dialog style="" header="Hủy bỏ" :visible.sync="showCancelDialog" :contentStyle="{overflow: 'visible'}" :modal="true">
          <div style="width: 385px;">
            <span>Bạn có chắc muốn huỷ SRA này không, trạng thái sẽ được chuyển thành Đã huỷ?</span>
          </div>
          <template #footer >
            <Button label="Hủy" @click="showCancelDialog = false" icon="pi pi-times" class="p-button-disa"/>
            <Button label="Xác nhận" @click="updateStatus('CANCEL')" icon="pi pi-check" class="" />
          </template>
        </Dialog>

        <Dialog style="" header="Duyệt gói công việc" :visible.sync="showApproveDialog" :contentStyle="{overflow: 'visible'}" :modal="true">
          <div style="width: 380px;">
            <span>Bạn xác nhận đã xem thông tin gói công việc và cập nhật trạng thái:</span>
          </div>
          <div style="padding-top: 4px;">
            <div v-if="infoApproved.status=='APPROVED'" style="display:flex">
                <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
                <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
            </div>
            <div v-else style="display:flex">
                <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
                <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
            </div>
            <!-- <div style="display:flex">
              <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;width: 50%;"/>
              <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;width: 50%;"/>
            </div> -->
          </div>
          <div v-if="infoApproved.status=='REJECTED'" style="padding-top: 6px;">
            <Textarea style="width:100%" v-model="infoApproved.note" type="text" rows="2" maxLength="2000" placeholder="Nhập lý do từ chối tại đây..."/>
          </div>
          <template #footer >
            <Button label="Hủy" @click="showApproveDialog = false" icon="pi pi-times" class="p-button-disa"/>
            <Button label="Xác nhận" @click="updateStatusSel()" icon="pi pi-check" class="" />
          </template>
        </Dialog>

        <Dialog style="" header="Lý do từ chối" :visible.sync="showRejectNote" :contentStyle="{overflow: 'visible'}" :modal="true">
            <div style="width: 385px;">
                <span>{{reject_note}}</span>
            </div>
            <template #footer >
                <Button label="Xác nhận" @click="showRejectNote = false" icon="pi pi-check" class="" />
            </template>
        </Dialog>

        <Dialog style="" :header="title_kdt" :visible.sync="showUpdateLesson" :contentStyle="{maxHeight: '80vh'}" :modal="true">
            <div>
              <label class="txt-left required" style="min-width:400px;">Khóa đào tạo</label>
              <DropdownScrollable
                :disabled="info_course.id !== null"
                placeholder="Chọn"
                :showClear="true"
                cusClass="m-0 cs-width"
                :limit="sra_course_obj.limit"
                :loading="sra_course_obj.loading"
                v-model="sra_course"
                :options="sra_course_obj.items"
                :total="sra_course_obj.total"
                @keyup="emitEventListSraCourse"
                @scroll="emitEventListSraCourse"
                @offset="changeOffsetListSraCourse"
              />
              <input class="input_tmp_validator" id="sra_course" />
            </div>
            <div>
                <label class="txt-left">Thời gian học</label>
                <InputText v-model="info_course.time_text" type="text" class="cs-input input-text-box" placeholder="Nhập" id="time_text"/>
            </div>
            <div>
                <label class="txt-left">Địa điểm học</label>
                <InputText v-model="info_course.address" type="text" class="cs-input input-text-box" placeholder="Nhập" id="time_text"/>
            </div>
            <div>
                <label class="txt-left">Tài liệu khóa học</label>
                <input class="input_tmp_validator" id="files">
                <div class="cus-text">Dung lượng tối đa: 50 MB</div>
                <div class="cus-text">Định dạng file: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.</div>
                <input class="p-inputtext p-component text-box-a" multiple style="background-color: #EEEEEE;" accept=".docx, .doc, .xlsx, .xls, .pptx, .pdf, .png, .jpg, .jpeg" name="files[]" type="file" @change="onFileSelect2"/>
                <div class="box-images text-box-a" v-if="info_course && info_course.files && info_course.files.length > 0">
                    <div class="d-flex align-items-center" v-for="(item, index) in info_course.files" :key="index" >
                        <div class="file-name" @click="openFile(item)" style="cursor: pointer; color: blue; text-decoration: underline;">{{ item.name }}</div>
                        <span v-if="item.created_at" style="padding-left: 3px;padding-right: 3px;">{{ item.created_at ? formatDateFile(item.created_at) : '' }}</span>
                        <Button icon="pi pi-download" class="p-button-download p-button-link" @click="onFileDownload(index)"/>
                        <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClear2(index)"/>
                    </div>
                </div>
                <div v-if="loading_here" class="loading-overlay">
                    <div class="spinner"></div>
                    <p>Đang tải lên...</p>
                </div>
            </div>
            <template #footer >
                <Button label="Hủy" @click="showUpdateLesson = false" icon="pi pi-times" class="p-button-disa"/>
                <Button label="Xác nhận" @click="UpdateLesson()" icon="pi pi-check" class="" />
            </template>
        </Dialog>

        <Dialog style="" header="Xóa" :visible.sync="showDeleteDialog" :contentStyle="{overflow: 'visible'}" :modal="true">
          Bạn có chắc muốn xoá lớp học này?
          <template #footer>
            <Button label="Hủy" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-disa" />
            <Button label="Xóa" @click="deleteDataCourse()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>

        <Dialog style="" header="Thêm file đính kèm" :visible.sync="showAddControlMeasuresFileDialog" :contentStyle="{overflow: 'visible','overflow-y': 'scroll'}" :modal="true">
            <div style="padding-top: 0px;min-width:400px;">
                <div class="cus-text">Dung lượng tối đa: 50 MB</div>
                <div class="cus-text">Định dạng file: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.</div>
                <input class="p-inputtext p-component text-box-a" multiple style="background-color: #EEEEEE;" accept=".docx, .doc, .xlsx, .xls, .pptx, .pdf, .png, .jpg, .jpeg" name="files[]" type="file" @change="onFileSelectControlMeasures"/>
                <div v-if="cm_file_loading" class="loading-overlay">
                    <div class="spinner"></div>
                    <p>Đang tải lên...</p>
                </div>
                <div class="box-images text-box-a" v-if="control_measures_files_dialog && control_measures_files_dialog.length > 0">
                    <div class="d-flex align-items-center" v-for="(item, index) in control_measures_files_dialog" :key="index">
                        <div class="file-name">{{ item.name }}</div>
                        <Button icon="pi pi-download" class="p-button-download p-button-link" @click="onFileDownloadControlMeasuresDialog(index)"/>
                        <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClearControlMeasures(index)"/>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button label="Hủy" @click="showAddControlMeasuresFileDialog = false" icon="pi pi-times" class="p-button-disa"/>
                <Button label="Xác nhận" @click="saveControlMeasuresFile()" icon="pi pi-check" class="" />
            </template>
        </Dialog>

        <Dialog style="" header="Thêm file đính kèm" :visible.sync="showAddWorkPermitFileDialog" :contentStyle="{overflow: 'visible','overflow-y': 'scroll'}" :modal="true">
            <div style="padding-top: 0px;min-width:400px;">
                <div class="cus-text">Dung lượng tối đa: 50 MB</div>
                <div class="cus-text">Định dạng file: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.</div>
                <input class="p-inputtext p-component text-box-a" multiple style="background-color: #EEEEEE;" accept=".docx, .doc, .xlsx, .xls, .pptx, .pdf, .png, .jpg, .jpeg" name="files[]" type="file" @change="onFileSelectWorkPermit"/>
                <div v-if="wp_file_loading" class="loading-overlay">
                    <div class="spinner"></div>
                    <p>Đang tải lên...</p>
                </div>
                <div class="box-images text-box-a" v-if="work_permit_files_dialog && work_permit_files_dialog.length > 0">
                    <div class="d-flex align-items-center" v-for="(item, index) in work_permit_files_dialog" :key="index">
                        <div class="file-name">{{ item.name }}</div>
                        <Button icon="pi pi-download" class="p-button-download p-button-link" @click="onFileDownloadWorkPermitDialog(index)"/>
                        <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClearWorkPermit(index)"/>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button label="Hủy" @click="showAddWorkPermitFileDialog = false" icon="pi pi-times" class="p-button-disa"/>
                <Button label="Xác nhận" @click="saveWorkPermitFile()" icon="pi pi-check" class="" />
            </template>
        </Dialog>

        <Dialog style="" header="Cấp giấy phép vào cổng" :visible.sync="showEPDialog" :contentStyle="{overflow: 'visible'}" :modal="true">
            <div style="width: 400px;">
                Bạn xác nhận các nhân sự được chọn của nhà thầu này đã đầy đủ hồ sơ yêu cầu và xác nhận rằng cấp giấy vào cổng?
            </div>
            <div>
                <label class="txt-left">Nhân viên nhà thầu</label>
                <InputText disabled v-model="ep_fullname" type="text" class="cs-input input-text-box"/>
            </div>
            <div>
                <label class="txt-left required">Thời gian hiệu lực</label>
                <Calendar v-model="ep_data_date" selectionMode="range" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY - DD/MM/YYYY"/>
            </div>
            <div>
                <label class="txt-left required">Nhà máy</label>
                <DropdownScrollable
                    placeholder="Chọn"
                    :showClear="true"
                    cusClass="m-0 cs-width"
                    :limit="ep_factory_obj.limit"
                    :loading="ep_factory_obj.loading"
                    v-model="ep_factory"
                    :options="ep_factory_obj.items"
                    :total="ep_factory_obj.total"
                />
            </div>
            <div>
                <label class="txt-left required">Khu vực làm việc</label>
                <DropdownScrollable
                    placeholder="Chọn"
                    :showClear="true"
                    :multiple="false"
                    cusClass="m-0 cs-width"
                    :limit="ep_areas_obj.limit"
                    :loading="ep_areas_obj.loading"
                    v-model="ep_areas_sel"
                    :options="ep_areas_obj.items"
                    :total="ep_areas_obj.total"
                    @keyup="emitEventListAreas"
                    @scroll="emitEventListAreas"
                />
            </div>
            <div class="mt-2">
              <label v-for="(item, index) in ep_areas" :key="index" class="cus-tags">
                <span class="cs-tag">
                  {{item.name}}
                </span>
                <i class="fas fa-times cs-icon" v-on:click="removeEpAreas(index)"></i>
              </label>
            </div>
            <template #footer>
                <Button label="Hủy" @click="showEPDialog = false" icon="pi pi-times" class="p-button-disa" />
                <Button label="Xác nhận" @click="approvedCapGiayEP()" icon="pi pi-check" class="" />
            </template>
        </Dialog>
        <Dialog style="" header="Xóa" :visible.sync="showDeleteDialogNS" :contentStyle="{overflow: 'visible'}" :modal="true">
            Bạn có chắc muốn xoá nhân sự này ra khỏi gói công việc này không?
          <template #footer>
            <Button label="Hủy" @click="showDeleteDialogNS = false" icon="pi pi-times" class="p-button-disa" />
            <Button label="Xóa" @click="deleteDataNSu()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
        <Dialog style="" header="Xóa" :visible.sync="showDeleteDialogVTTB" :contentStyle="{overflow: 'visible'}" :modal="true">
            Bạn có chắc muốn xoá vật tư/ thiết bị này khỏi gói công việc không?
          <template #footer>
            <Button label="Hủy" @click="showDeleteDialogVTTB = false" icon="pi pi-times" class="p-button-disa" />
            <Button label="Xóa" @click="deleteDataVTTBi()" icon="pi pi-check" class="p-button-danger" />
          </template>
        </Dialog>
        <Dialog style="" :header="course_lesson.name" :visible.sync="showCoureLesson" :contentStyle="{overflow: 'auto'}" :modal="true">
            <div style="">
                <span v-if="course_lesson.time_text !==''">- {{course_lesson.time_text}}</span>
            </div>
            <div style="">
                <span v-if="course_lesson.address !==''">- {{course_lesson.address}}</span>
            </div>
            <!-- <Calendar dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY"/> -->
            <br>
            <!-- <div style="overflow-y: scroll; max-height: 400px;"> -->
            <table id="dialog_table" style="">
                <tr>
                    <th style="width: 32px;">STT</th>
                    <th>Username</th>
                    <th style="">Tên hiển thị</th>
                    <th style="width:100px;">Kết quả</th>
                    <th style="width:90px;">Hiệu lực đến</th>
                </tr>
                <tr v-for="(item, index) in course_lesson.users" :key="index">
                    <td>{{index + 1}}</td>
                    <td>{{item.username}}</td>
                    <td>{{item.fullname}}</td>
                    <td>
                        <Dropdown class="dialog-drop" :disabled="course_lesson.disabled==true || item.status=='PASS' || item.status == 'FAILED'" v-model="item.selStatus" optionValue="value" :options="list_status_lesson" optionLabel="label" placeholder="Chọn" @change="onStatusChange(item)"/>
                    </td>
                    <td>
                        <Calendar v-model="item.expiration_date_show" disabled dateFormat="dd/mm/yy" :showIcon="false" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY"/>
                    </td>
                </tr>
            </table>
            <!-- </div> -->

          <template #footer>
            <Button label="Hủy" @click="showCoureLesson = false" icon="pi pi-times" class="p-button-disa" />
            <Button v-if="course_lesson.showapproved==true" label="Xác nhận" @click="approvedKhoaHoc()" icon="pi pi-check" class="" />
          </template>
        </Dialog>

        <Dialog style="" header="Đóng công việc" :visible.sync="showCloseSRA" :contentStyle="{overflow: 'visible',overflowY: 'auto'}" :modal="true">
            Bạn xác nhận gói công việc này đã hoàn tất và xác nhận đóng. Bạn có chắc muốn tiếp tục không?
          <template #footer>
            <Button label="Hủy" @click="showCloseSRA = false" icon="pi pi-times" class="p-button-disa" />
            <Button label="Xác nhận" @click="closeSRA()" icon="pi pi-check" class="" />
          </template>
        </Dialog>

        <Dialog style="" header="Gửi nhà thầu" :visible.sync="showGuiNhaThau" :contentStyle="{overflow: 'visible',overflowY: 'auto'}" :modal="true">
            <div style="">
                <label class="txt-left" style="width:700px;">Admin nhà thầu</label>
                <DropdownScrollable
                    placeholder="Chọn"
                    :showClear="true"
                    cusClass="m-0 cs-width"
                    :multiple="false"
                    defaultLabel="fullname"
                    :limit="list_admin_contractor_obj.limit"
                    :loading="list_admin_contractor_obj.loading"
                    v-model="list_admin_contractor_sel"
                    :options="list_admin_contractor_obj.items"
                    :total="list_admin_contractor_obj.total"
                    @keyup="emitEventListAdminContractor"
                    @scroll="emitEventListAdminContractor"
                />
            </div>
            <div class="mt-1" style="width:700px;">
                <label v-for="(item, index) in list_admin_contractor" :key="index" class="cus-tags">
                    <span class="cs-tag">
                        {{item.fullname}}
                    </span>
                    <i class="fas fa-times cs-icon" v-on:click="removeListAdminContractor(index)"></i>
                </label>
            </div>
            <div class="mt-1" style="width:700px;">
                <label class="txt-left">Đối tượng nhận email khác</label>
                <InputText v-model="tag_text" @keydown.enter="handleEnter" placeholder="Nhập email nhận thông báo và nhấn Enter" />
            </div>
            <div class="mt-1" style="width:700px;">
                <label v-for="(item, index) in tags_show" :key="index" class="cus-tags">
                <span class="cs-tag">
                    {{item}}
                </span>
                <i class="fas fa-times cs-icon" v-on:click="removeTagsShow(index)"></i>
                </label>
            </div>
            <div class="mt-1" style="width:700px;">
                <label class="txt-left required">Subject</label>
                <InputText v-model="subject_text" maxLength="125" placeholder="Nhập subject tối đa 125 ký tự" />
            </div>
            <div class="mt-1" style="width:700px;">
                <label class="txt-left required">Nội dung</label>
                <CKditorCore v-model="content_text" />
            </div>
            <template #footer>
                <Button label="Hủy" @click="showGuiNhaThau = false" icon="pi pi-times" class="p-button-disa" />
                <Button label="Gửi" @click="SendEmailNT()" icon="pi pi-check" class="" />
            </template>
        </Dialog>

        <Dialog style="" header="Gửi chủ đầu tư" :visible.sync="showGuiChuDauTu" :contentStyle="{overflow: 'visible',overflowY: 'auto'}" :modal="true">
            <div v-if="company_type != 'option_1'" class="mt-1" style="width:700px;">
                <label class="txt-left">Công ty</label>
                <DropdownScrollable
                    placeholder="Chọn"
                    :showClear="true"
                    cusClass="m-0 cs-width"
                    :multiple="false"
                    v-model="company_info"
                    :options="company_obj.items"
                    :total="company_obj.total"
                    readonly
                />
            </div>
            <div class="mt-1" style="width:700px;">
                <label class="txt-left">{{ company_type == 'option_1' ? 'Admin công ty' : 'Chủ đầu tư' }}</label>
                <DropdownScrollable
                    placeholder="Chọn"
                    :showClear="true"
                    cusClass="m-0 cs-width"
                    :multiple="false"
                    defaultLabel="fullname"
                    :limit="list_admin_company_obj.limit"
                    :loading="list_admin_company_obj.loading"
                    v-model="list_admin_company_sel"
                    :options="list_admin_company_obj.items"
                    :total="list_admin_company_obj.total"
                    @keyup="emitEventListAdminCompany"
                    @scroll="emitEventListAdminCompany"
                />
            </div>
            <div class="mt-1" style="width:700px;">
                <label v-for="(item, index) in list_admin_company" :key="index" class="cus-tags">
                    <span class="cs-tag">
                        {{item.fullname}}
                    </span>
                    <i class="fas fa-times cs-icon" v-on:click="removeListAdminCompany(index)"></i>
                </label>
            </div>
            <!-- <div class="mt-1" style="width:700px;">
                <label class="txt-left">Đối tượng nhận email khác</label>
                <InputText v-model="tag_text" @keydown.enter="handleEnter" placeholder="Nhập email nhận thông báo và nhấn Enter" />
            </div> -->
            <div class="mt-1" style="width:700px;">
                <label v-for="(item, index) in tags_show" :key="index" class="cus-tags">
                <span class="cs-tag">
                    {{item}}
                </span>
                <i class="fas fa-times cs-icon" v-on:click="removeTagsShow(index)"></i>
                </label>
            </div>
            <div v-if="company_type == 'option_1'" class="mt-1" style="width:700px;">
                <label class="txt-left">Người liên quan đến gói công việc</label>
                <DropdownScrollable
                    placeholder="Chọn"
                    :showClear="true"
                    cusClass="m-0 cs-width"
                    :multiple="false"
                    defaultLabel="fullname"
                    :limit="sra_related_user_obj.limit"
                    :loading="sra_related_user_obj.loading"
                    v-model="sra_related_user_sel"
                    :options="sra_related_user_obj.items"
                    :total="sra_related_user_obj.total"
                    @keyup="emitEventSraRelatedUsers"
                    @scroll="emitEventSraRelatedUsers"
                />
            </div>
            <div v-if="company_type == 'option_1'" class="mt-1" style="width:700px;">
                <label v-for="(item, index) in sra_related_users" :key="`sra-related-user-${item.id}`" class="cus-tags">
                    <span class="cs-tag">
                        {{item.fullname}}
                    </span>
                    <i class="fas fa-times cs-icon" v-on:click="removeSraRelatedUser(index)"></i>
                </label>
            </div>
            <div class="mt-1" style="width:700px;">
                <label class="txt-left required">Subject</label>
                <InputText v-model="subject_text" maxLength="125" placeholder="Nhập subject tối đa 125 ký tự" />
            </div>
            <div class="mt-1" style="width:700px;">
                <label class="txt-left required">Nội dung</label>
                <CKditorCore v-model="content_text" />
            </div>
            <template #footer>
                <Button label="Hủy" @click="showGuiChuDauTu = false" icon="pi pi-times" class="p-button-disa" />
                <Button label="Gửi" @click="SendEmailCDT()" icon="pi pi-check" class="" />
            </template>
        </Dialog>

        <Dialog style="" header="Vi phạm an toàn" :visible.sync="showVPATDialog" :contentStyle="{overflow: 'visible'}" :modal="true">
            <div style="width: 400px;">
                Bạn xác nhận các nhân sự được chọn đã <span style="font-weight: 700;">vi phạm an toàn</span>?
            </div>
            <div>
                <label class="txt-left">Nhân viên nhà thầu</label>
                <InputText disabled v-model="ep_fullname" type="text" class="cs-input input-text-box"/>
            </div>
            <div>
                <label class="txt-left">Vi phạm an toàn</label>
                <DropdownScrollable
                    placeholder="Chọn"
                    :showClear="false"
                    cusClass="m-0 cs-width"
                    width="100%"
                    defaultLabel="label"
                    :multiple="false"
                    :limit="vpat_violations_obj.limit"
                    :loading="vpat_violations_obj.loading"
                    v-model="vpat_violations_sel"
                    :options="vpat_violations_obj.items"
                    :total="vpat_violations_obj.total"
                    @keyup="emitEventVPATViolations"
                    @scroll="emitEventVPATViolations"
                    @offset="changeOffsetVPATViolations"
                />
            </div>
            <div class="mt-2">
                <label v-for="(item, index) in vpat_violations" :key="'vpat-violations-' + item.id + '-' + index" class="cus-tags">
                    <span class="cs-tag">
                        {{item.label}}
                    </span>
                    <i class="fas fa-times cs-icon" v-on:click="removeVPATViolation(index)"></i>
                </label>
            </div>
            <div class="mt-2">
                <label class="txt-left">Ngày vi phạm</label>
                <Calendar v-model="vpat_date" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY"/>
            </div>
            <template #footer>
                <Button label="Hủy" @click="showVPATDialog = false" icon="pi pi-times" class="p-button-disa" />
                <Button label="Xác nhận" @click="approvedVPAT()" icon="pi pi-check" class="" />
            </template>
        </Dialog>

        <Dialog style="" header="Loại TNLĐ/Sự cố an toàn" :visible.sync="showSCATDialog" :contentStyle="{overflow: 'visible'}" :modal="true">
            <div style="width: 400px;">
                Bạn xác nhận các nhân sự được chọn đã <span style="font-weight: 700;">gặp tai nạn lao động/sự cố an toàn</span>?
            </div>
            <div>
                <label class="txt-left">Nhân viên nhà thầu</label>
                <InputText disabled v-model="ep_fullname" type="text" class="cs-input input-text-box"/>
            </div>
            <div>
                <label class="txt-left">Loại TNLĐ/Sự cố an toàn</label>
                <DropdownScrollable
                    placeholder="Chọn"
                    :showClear="false"
                    cusClass="m-0 cs-width"
                    width="100%"
                    defaultLabel="label"
                    :multiple="false"
                    :limit="scat_violations_obj.limit"
                    :loading="scat_violations_obj.loading"
                    v-model="scat_violations_sel"
                    :options="scat_violations_obj.items"
                    :total="scat_violations_obj.total"
                    @keyup="emitEventSCATViolations"
                    @scroll="emitEventSCATViolations"
                    @offset="changeOffsetSCATViolations"
                />
            </div>
            <div class="mt-2">
                <label v-for="(item, index) in scat_violations" :key="'scat-violations-' + item.id + '-' + index" class="cus-tags">
                    <span class="cs-tag">
                        {{item.label}}
                    </span>
                    <i class="fas fa-times cs-icon" v-on:click="removeSCATViolation(index)"></i>
                </label>
            </div>
            <div class="mt-2">
                <label class="txt-left">Ngày xảy ra sự cố</label>
                <Calendar v-model="scat_date" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY"/>
            </div>
            <template #footer>
                <Button label="Hủy" @click="showSCATDialog = false" icon="pi pi-times" class="p-button-disa" />
                <Button label="Xác nhận" @click="approvedSCAT()" icon="pi pi-check" class="" />
            </template>
        </Dialog>

        <Dialog
            :header="'Lịch sử vi phạm của ' + violationHistoryUserName"
            :visible.sync="showViolationHistoryModal"
            :style="{ width: '70vw' }"
            :contentStyle="{ overflow: 'auto' }"
            :modal="true"
        >
            <DataTable
                :value="violationHistoryList"
                responsiveLayout="scroll"
                :loading="violationHistoryLoading"
                class="p-datatable-sm"
            >
                <Column header="STT" headerStyle="width: 70px">
                    <template #body="slotProps">
                        {{ slotProps.index + 1 }}
                    </template>
                </Column>
                <Column field="violation_date_text" header="Ngày vi phạm" headerStyle="width: 150px"></Column>
                <Column field="violation_reason" header="Lý do"></Column>
                <Column field="created_fullname" header="Người ghi nhận" headerStyle="width: 180px"></Column>
            </DataTable>
            <!-- <div v-if="violationHistoryList.length === 0" class="blacklist-empty">
                Không có dữ liệu.
            </div> -->
            <template #footer>
                <Button label="Đóng" @click="showViolationHistoryModal = false" icon="pi pi-times" class="p-button-disa" />
            </template>
        </Dialog>

        <Dialog
            :header="'Lịch sử TNLĐ/SCAT của ' + incidentHistoryUserName"
            :visible.sync="showIncidentHistoryModal"
            :style="{ width: '70vw' }"
            :contentStyle="{ overflow: 'auto' }"
            :modal="true"
        >
            <DataTable
                :value="incidentHistoryList"
                responsiveLayout="scroll"
                :loading="incidentHistoryLoading"
                class="p-datatable-sm"
            >
                <Column header="STT" headerStyle="width: 70px">
                    <template #body="slotProps">
                        {{ slotProps.index + 1 }}
                    </template>
                </Column>
                <Column field="violation_date_text" header="Ngày xảy ra sự cố" headerStyle="width: 150px"></Column>
                <Column field="incident_reason" header="Loại TNLĐ/Sự cố an toàn"></Column>
                <Column field="created_fullname" header="Người ghi nhận" headerStyle="width: 180px"></Column>
            </DataTable>
            <template #footer>
                <Button label="Đóng" @click="showIncidentHistoryModal = false" icon="pi pi-times" class="p-button-disa" />
            </template>
        </Dialog>

        <div v-if="loading_download" class="loading-overlay">
            <div class="spinner"></div>
            <p>Đang chuẩn bị tải xuống...</p>
        </div>
  </div>
</template>

<script>
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";
import jq from 'jquery';
import DropdownScrollable from '@/components/DropdownScrollable_v2';
import CKditorCore from '@/views/admin/CkditorCoreCourse.vue';
import JSZip from "jszip";
import { saveAs } from "file-saver";
export default {
  directives: {
    // giữ chuột kéo ngang để cuộn bảng + thanh cuộn ngang phụ phía trên bảng (luôn thấy được, không phụ thuộc kích thước màn hình)
    dragScroll: {
      inserted(el) {
        var bar = document.createElement('div');
        bar.className = 'scroll-top-bar';
        var inner = document.createElement('div');
        inner.style.height = '1px';
        bar.appendChild(inner);
        el.parentNode.insertBefore(bar, el);
        el._scrollBar = bar;
        bar.addEventListener('scroll', function () {
          if (el.scrollLeft !== bar.scrollLeft) el.scrollLeft = bar.scrollLeft;
        });
        el.addEventListener('scroll', function () {
          if (bar.scrollLeft !== el.scrollLeft) bar.scrollLeft = el.scrollLeft;
        });
        var update = function () {
          inner.style.width = el.scrollWidth + 'px';
          bar.style.display = el.scrollWidth > el.clientWidth ? 'block' : 'none';
        };
        if (window.ResizeObserver) {
          el._resizeObserver = new ResizeObserver(update);
          el._resizeObserver.observe(el);
          var table = el.querySelector('table');
          if (table) el._resizeObserver.observe(table);
        }
        update();
        var down = false, moved = false, startX = 0, startY = 0, scrollLeft = 0, scrollTop = 0;
        el.addEventListener('mousedown', function (e) {
          // không kéo khi bấm vào nút, checkbox, link, ô nhập
          if (e.button !== 0 || e.target.closest('button, a, input, select, textarea, .p-checkbox, .span-link')) return;
          down = true;
          moved = false;
          startX = e.pageX;
          startY = e.pageY;
          scrollLeft = el.scrollLeft;
          scrollTop = el.scrollTop;
        });
        window.addEventListener('mousemove', el._dragMove = function (e) {
          if (!down) return;
          var dx = e.pageX - startX, dy = e.pageY - startY;
          if (!moved && Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
          moved = true;
          el.classList.add('dragging');
          el.scrollLeft = scrollLeft - dx;
          el.scrollTop = scrollTop - dy;
          e.preventDefault();
        });
        window.addEventListener('mouseup', el._dragUp = function () {
          if (!down) return;
          down = false;
          el.classList.remove('dragging');
          if (moved) {
            // chặn click sau khi kéo
            var block = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
            el.addEventListener('click', block, {capture: true, once: true});
            setTimeout(function () { el.removeEventListener('click', block, true); }, 0);
          }
        });
      },
      unbind(el) {
        if (el._resizeObserver) el._resizeObserver.disconnect();
        if (el._scrollBar && el._scrollBar.parentNode) el._scrollBar.parentNode.removeChild(el._scrollBar);
        window.removeEventListener('mousemove', el._dragMove);
        window.removeEventListener('mouseup', el._dragUp);
      },
    },
  },
  components: {
    DropdownScrollable,
    CKditorCore
  },
  data() {
    return {
        hideTab : 1,
        name_tab:["Thông tin chung","Cập nhật hồ sơ nhà thầu","Cập nhật nhân sự","Khóa đào tạo","Cập nhật vật tư & thiết bị","Điểm danh","Đánh giá"],
        users: null,
        show_cancel : false,
        show_edit : false,
        show_approved : false,
        mode: 'view',
        model: {},
        page_transaction:null,
        company_id: null,
        currentTab : 0,
        view_id : null,
        name : '',
        show_1 : true,
        show_2 : true,
        company : null,
        factory : null,
        areas : [],
        areas_text : '',
        data_date_text : '',
        status_text : '',
        status : '',
        fullname_c1 : '',
        fullname_c2 : '',
        supervisor_text : '',
        contractor_html : '',
        description : '',
        danger_text : [],
        control_measures_text : '',
        yc_doanhnghiep : '',
        yc_nhansu : '',
        yc_kdt : '',
        yc_thietbi : '',
        yc_vattu : '',
        showCancelDialog : false,
        showApproveDialog : false,
        showRejectNote : false,
        infoApproved: {
            status : '',
            note : ''
        },
        reject_note : '',
        list_tab_yc_contractor : [
            // {stt : 1,id : '1',name : 'Giấy phép đăng ký kinh doanh',list_file : [],status : 'NEEDS_UPDATE',status_html : '<span style="color:#333333">Cần cập nhật</span>',updated_fullname : 'người cập nhật', time : "2024-01-10 21:25:20"},
            // {stt : 2,id : '2',name : 'Kế hoạch an toàn vệ sinh lao động của nhà thầu',list_file : [],status : 'NEEDS_UPDATE',status_html : '<span style="color:#333333">Cần cập nhật</span>',updated_fullname : 'người cập nhật', time : "2024-01-10 21:25:20"}
        ],
        list_tab_yc_nhansu : [],
        list_tab_kdt : [],
        title_kdt : 'Thêm khóa đào tạo',
        sra_course : null,
        sra_course_obj : {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
        },
        showUpdateLesson : false,
        info_course : {
            time_text : '',
            address : '',
            id : null,
            files : []
        },
        deleteData : null,
        showDeleteDialog : false,
        list_tab_yc_vttb : [],
        check_all : false,
        select_nscheck : [],
        showEPDialog : false,
        ep_fullname : '',
        ep_data_date : [],
        ep_factory : null,
        ep_factory_obj : {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
        },
        deleteDataNS : null,
        showDeleteDialogNS : false,
        showDeleteDialogVTTB : false,
        deleteDataVTTB : null,
        ep_areas_obj : {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
        },
        ep_areas : [],
        is_load_data : false,
        showCoureLesson : false,
        course_lesson : {
            type : '',
            course_name : '',
            time_text : '',
            address : '',
            users : [],
            disabled : true,
            showapproved : false
        },
        list_status_lesson : [
            {value: 'PASS', label: 'Đạt'},
            {value: 'FAILED', label: 'Chưa đạt'},
        ],
        atw_id : null,
        showCloseSRA : false,
        ep_areas_sel : null,
        showGuiNhaThau : false,
        list_admin_contractor_sel: null,
        list_admin_contractor : [],
        list_admin_contractor_obj : {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
        },
        contractor_id : null,
        tags_show : [],
        tag_text : '',
        subject_text : '',
        content_text : '',
        company_info : {
            
        },
        showGuiChuDauTu : false,
        list_admin_company_sel: null,
        list_admin_company : [],
        list_admin_company_obj : {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
        },
        sra_related_user_sel: null,
        sra_related_users: [],
        sra_related_user_obj: {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
        },
        company_sel : null,
        company_obj : {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
        },
        filesDeletes2_tmp : [],
        maxFileSize: 10485760*5,//1024*1024*50 = 50MB
        maxFiles : 100,
        maxFilesProfile: 100,
        loading: false,
        status_works : [
            {value : 'waiting', label : 'Chờ thực hiện'},
            {value : 'processing', label : 'Đang thực hiện'},
            {value : 'done', label : 'Hoàn thành'},
            {value : 'pending', label : 'Tạm dừng'},
        ],
        status_work : {value : 'waiting', label : 'Chờ thực hiện'},
        check_updated : false,
        loading_here: false,
        loading_download: false,
        exporting_excel: false,
        zone_html : '-',
        risk_level_html: '-',
        evaluationRateOptions: [
            { value: 1, label: 'Rất tệ' },
            { value: 2, label: 'Tệ' },
            { value: 3, label: 'Hoàn thành' },
            { value: 4, label: 'Tốt' },
            { value: 5, label: 'Rất tốt' },
        ],
        evaluationContinueOptions: [
            { value: 1, label: 'Không tiếp tục' },
            { value: 2, label: 'Tiếp tục' },
        ],
        evaluationBadgeOptions: [
            { value: 'A', label: 'A - Tốt', className: 'btn-switch-1' },
            { value: 'B', label: 'B - Trung Bình', className: 'btn-switch-2' },
            { value: 'C', label: 'C - Tệ', className: 'btn-switch-3' },
        ],
        evaluation: {
            safe_value: null,
            quality_value: null,
            continue_value: null,
            badge: null,
            note: '',
            incidents: [],
            violations: []
        },
        vpat_violations: [],
        vpat_violations_sel: null,
        vpat_violations_obj: {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
        },
        vpat_date: new Date(),
        showVPATDialog : false,
        scat_violations: [],
        scat_violations_sel: null,
        scat_violations_obj: {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
        },
        scat_date: new Date(),
        showSCATDialog : false,
        showViolationHistoryModal : false,
        violationHistoryLoading : false,
        violationHistoryList : [],
        violationHistoryUserName : '',
        showIncidentHistoryModal : false,
        incidentHistoryLoading : false,
        incidentHistoryList : [],
        incidentHistoryUserName : '',
        banned_reason: 'Vi phạm an toàn',
        show_vpat : false,
        show_scat : false,
        show_action : true,
        show_diemdanh :false,
        show_upd_time :false,
        showAttendanceModal : false,
        showAttendanceEditModal : false,
        showUpdateTotalHourModal : false,
        showDeleteAttendanceDialogModal : false,
        attendance_loading : false,
        list_tab_diemdanh : [],
        deleteAttendanceData : null,
        sra_total_hour: 0,
        sra_total_hour_input: 0,
        attendance_user_sel : null,
        attendance_users_sel : [],
        attendance_date_start : null,
        attendance_date_end : null,
        attendance_working_hours : 8,
        attendance_edit_data : {
            id: null,
            fullname: '',
            date_start: null,
            date_end: null,
            working_hours: 0
        },
        attendance_users_obj : {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
        },
        attendance_pagination : {
            offset: 0,
            limit: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT,
            total: 0
        },
        show_diemdanh_edit : false,
        show_diemdanh_deleted : false,
        company_type: '',
        request_nv:false,
        show_danhgia : false,
        files_evaluate : [],
        files_control_measures : [],
        showAddControlMeasuresFileDialog : false,
        control_measures_files_dialog : [],
        cm_file_loading : false,
        files_work_permit : [],
        showAddWorkPermitFileDialog : false,
        work_permit_files_dialog : [],
        wp_file_loading : false,
        showUpdateExecutionTimeModal : false,
        execution_time_start : null,
        execution_time_end : null,
        show_update_execution_time : false
    }
  },
  async mounted () {
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company_id = this.$route.query.company_id;
      }
      if (!this.$commonFuction.isEmpty(this.$route.query.ctab)){
        this.currentTab = this.$route.query.ctab;
      }
    }
    if (this.$route.params.id !== undefined) {
        this.view_id = this.$route.params.id
        await this.getData(this.$route.params.id);
        if (this.model !== undefined && Object.keys(this.model).length > 0) {
            console.log("this.model===",this.model)
            this.name = this.model.name
            this.sra_total_hour = this.model.sra_total_hour ?? 0
            this.sra_total_hour_input = this.model.sra_total_hour ?? 0
            this.company = this.model.company
            this.factory = this.model.factory
            this.company_type = this.model.company.company_type ?? ''
            if(this.model.status_work == 'waiting'){
                this.status_work = {value : 'waiting', label : 'Chờ thực hiện'}
            }else if(this.model.status_work == 'processing'){
                this.status_work = {value : 'processing', label : 'Đang thực hiện'}
            }else if(this.model.status_work == 'done'){
                this.status_work = {value : 'done', label : 'Hoàn thành'}
            }else if(this.model.status_work == 'pending'){
                this.status_work = {value : 'pending', label : 'Tạm dừng'}
            }
            // var type_login = this.$store.getters.type ? this.$store.getters.type : null;
            // if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            //     this.check_updated = true;
            //     this.show_update_execution_time = true;
            // }
            // if(this.model.created_by == this.$store.getters.user){
            //     this.check_updated = true;
            //     this.show_update_execution_time = true;
            // }
            // check_updated, show_update_execution_time được set trong setRoleSra()

            if(this.model.atw){
                this.atw_id = this.model.atw.id
            }
            var areas_text = ''
            var areas = []
            if(this.model.sra_areas && this.model.sra_areas.length > 0){
                for (let i = 0; i < this.model.sra_areas.length; i++) {
                    areas.push(this.model.sra_areas[i])
                    if(areas_text !== ''){
                        areas_text += '; '+this.model.sra_areas[i].name
                    }else{
                        areas_text = this.model.sra_areas[i].name
                    }
                }
            }
            this.areas_text = areas_text
            this.areas = areas
            var data_date_text = ''
            if(this.model.date_start){
                data_date_text = moment(this.model.date_start).format("DD/MM/YYYY")
            }else{data_date_text = '?'}
            if(this.model.display_end_date){
                data_date_text += ' - '+moment(this.model.display_end_date).format("DD/MM/YYYY")
            }else{data_date_text = ' - ?'}
            this.data_date_text = data_date_text
            this.getStatus(this.model.status,this.model.uid_c1,this.model.uid_c2,this.model.created_by)
            this.reject_note = this.model.reject_note
            this.fullname_c1 = this.model.fullname_c1 ?? ''
            this.fullname_c2 = this.model.fullname_c2 ?? ''
            var supervisor_text = ''
            if(this.model.sra_supervisor && this.model.sra_supervisor.length > 0){
                for (let i = 0; i < this.model.sra_supervisor.length; i++) {
                    if(supervisor_text !== ''){
                        supervisor_text += '; '+this.model.sra_supervisor[i].fullname
                    }else{
                        supervisor_text = this.model.sra_supervisor[i].fullname
                    }
                }
            }
            this.supervisor_text = supervisor_text
            var contractor_html = '-'
            if(this.model.contractor){
                this.contractor_id = this.model.contractor_id
                if (this.$store.getters.controllers?.list_contractor && this.$store.getters.controllers?.list_contractor.includes('edit')) {
                    contractor_html = '<a class="css-underline" href="/admin/list-contractor/edit/'+this.model.contractor_id+'?company_id='+this.company.id+'">['+this.model.contractor.code+'] '+this.model.contractor.name+'</a>'
                }else{
                    contractor_html = '<span>['+this.model.contractor.code+'] '+this.model.contractor.name+'</span>'
                }
            }
            this.contractor_html = contractor_html
            var zone_html = '-'
            if(this.model.zone){
                zone_html = this.model.zone.name ?? '-'
            }
            this.zone_html = zone_html
            var risk_level_html = '-'
            if(this.model.risk_level){
                if(this.model.risk_level == 'HIGH'){
                    // risk_level_html = '<span style="color:red;">Cao</span>'
                    risk_level_html = '<div class="risk-cs-h-1"><span class="risk-span">Cao</span></div>'
                }else if(this.model.risk_level == 'MEDIUM'){
                    // risk_level_html = '<span style="color:orange;">Trung bình</span>'
                    risk_level_html = '<div class="risk-cs-m-1"><span class="risk-span">Trung bình</span></div>'
                }else if(this.model.risk_level == 'LOW'){
                    // risk_level_html = '<span style="color:green;">Thấp</span>'
                    risk_level_html = '<div class="risk-cs-l-1"><span class="risk-span">Thấp</span></div>'
                }
            }
            this.risk_level_html = risk_level_html
            var request_nv = false
            if(this.model.request_nv){
                request_nv = true
            }
            this.request_nv = request_nv
            // this.description = this.model.description ?? ''
            this.description = this.formatTextToHtml(this.model.description)
            if(this.model.sra_danger && this.model.sra_danger.length > 0){
                for (let i = 0; i < this.model.sra_danger.length; i++) {
                    const e = this.model.sra_danger[i];
                    if(e.danger && e.danger.name){
                        this.danger_text.push(e.danger.name)
                    }
                }
            }
            this.control_measures_text = this.formatTextToHtml(this.model.control_measures)
            this.files_control_measures = this.model.file_control_measures ?? []
            this.files_work_permit = this.model.file_work_permit ?? []
            this.getYcDoanhNghiep(this.model.sra_files_contractor)//xử lý hiển thị data
            this.getYcNhanSu(this.model.sra_files_users,this.model.sra_course)//xử lý hiển thị data
            this.getYcThietBi(this.model.sra_files_equipment)//xử lý hiển thị data
            this.getYcVatTu(this.model.sra_files_supplies)//xử lý hiển thị data
            if(this.model.status == 'APPROVED'){
                this.listYcDoanhNghiep()//tab cập nhật hồ sơ nhà thầu
                this.listYcNhanSu()//tab cập nhật nhân sự
                this.listYcKhoaDaoTao()//tab khóa đào tạo
                this.listYcVatTuThietBi()//tab cập nhật vật tư và thiết bị
            }else{
                this.show_action = false
                this.listYcDoanhNghiep()//tab cập nhật hồ sơ nhà thầu
                this.listYcNhanSu()//tab cập nhật nhân sự
                this.listYcKhoaDaoTao()//tab khóa đào tạo
                this.listYcVatTuThietBi()//tab cập nhật vật tư và thiết bị
            }
            if(this.model.status=='CLOSE'){
                this.show_danhgia = true
                this.setEvaluationData()
                if(this.model.file_evaluate && this.model.file_evaluate.length > 0){
                    var l = []
                    for (let k = 0; k < this.model.file_evaluate.length; k++) {
                        const e = this.model.file_evaluate[k];
                        l.push(e)
                    }
                    this.files_evaluate = l
                }
            }
        }
    }
    // var show_vpat = this.$store.getters.controllers?.list_sra.includes('violation') ? true : false;
    // this.show_vpat = show_vpat
    // var show_scat = this.$store.getters.controllers?.list_sra.includes('incident') ? true : false;
    // this.show_scat = show_scat
    // var show_diemdanh = this.$store.getters.controllers?.list_sra.includes('attendance') ? true : false;
    // var show_diemdanh_edit = this.$store.getters.controllers?.list_sra.includes('attendance_edit') ? true : false;
    // var show_diemdanh_deleted = this.$store.getters.controllers?.list_sra.includes('attendance_delete') ? true : false;
    // var show_upd_time = this.$store.getters.controllers?.list_sra.includes('attendance_update_hour') ? true : false;
    // this.show_diemdanh = show_diemdanh
    // this.show_diemdanh_edit = show_diemdanh_edit
    // this.show_diemdanh_deleted = show_diemdanh_deleted
    // this.show_upd_time = show_upd_time
    this.setRoleSra()
  },
  watch : {
    // store controllers được set bất đồng bộ ở AdminLayout (menuService), load lại trang nhanh thì set lại quyền khi store cập nhật
    "$store.getters.controllers"() {
        this.setRoleSra()
    },
    async "ep_factory"() {
        if(this.is_load_data == true){//nếu thay đổi giá trị từ đổ dữ liệu ra thì không cần gọi
            return;
        }
        this.ep_areas_obj = {
            offset: 0,
            filters: {},
            limit: 20,
            items: [],
            total: 0,
            loading: false
        },
        this.ep_areas = []
        await this.getListAreas();
    },
    async "ep_areas_sel"() {
      if(this.$commonFuction.isEmptyObject(this.ep_areas_sel)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.ep_areas.length; i++) {
          if(this.ep_areas[i].id == this.ep_areas_sel.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.ep_areas.push(this.ep_areas_sel)
        }
        this.ep_areas_sel = null
      }
    },
    async "list_admin_contractor_sel"() {
        if(this.$commonFuction.isEmptyObject(this.list_admin_contractor_sel)){
            return
        }else{
            var check_exist = false;
            for (let i = 0; i < this.list_admin_contractor.length; i++) {
                if(this.list_admin_contractor[i].id == this.list_admin_contractor_sel.id){
                    check_exist = true;
                    break;
                }
            }
            if(check_exist == false){
                this.list_admin_contractor.push(this.list_admin_contractor_sel)
            }
            this.list_admin_contractor_sel = null
        }
    },
    async "list_admin_company_sel"() {
        if(this.$commonFuction.isEmptyObject(this.list_admin_company_sel)){
            return
        }else{
            var check_exist = false;
            for (let i = 0; i < this.list_admin_company.length; i++) {
                if(this.list_admin_company[i].id == this.list_admin_company_sel.id){
                    check_exist = true;
                    break;
                }
            }
            if(check_exist == false){
                this.list_admin_company.push(this.list_admin_company_sel)
                if(this.company_type == 'option_1'){
                    this.updateSraRelatedContent()
                }
            }
            this.list_admin_company_sel = null
        }
    },
    async "sra_related_user_sel"() {
        if(this.$commonFuction.isEmptyObject(this.sra_related_user_sel)){
            return
        }
        var check_exist = this.sra_related_users.some(item => item.id == this.sra_related_user_sel.id)
        if(check_exist == false){
            this.sra_related_users.push(this.sra_related_user_sel)
            this.updateSraRelatedContent()
        }
        this.sra_related_user_sel = null
    },
    "attendance_user_sel"() {
        if(this.$commonFuction.isEmptyObject(this.attendance_user_sel)){
            return
        }
        let check_exist = false
        for (let i = 0; i < this.attendance_users_sel.length; i++) {
            if((this.attendance_users_sel[i].uid ?? this.attendance_users_sel[i].id) == (this.attendance_user_sel.uid ?? this.attendance_user_sel.id)){
                check_exist = true
                break
            }
        }
        if(check_exist == false){
            this.attendance_users_sel.push(this.attendance_user_sel)
        }
        this.attendance_user_sel = null
    },
    "vpat_violations_sel"() {
        if(this.$commonFuction.isEmptyObject(this.vpat_violations_sel)){
            return
        }
        let check_exist = false
        for (let i = 0; i < this.vpat_violations.length; i++) {
            if(this.vpat_violations[i].id == this.vpat_violations_sel.id){
                check_exist = true
                break
            }
        }
        if(check_exist == false){
            this.vpat_violations.push(this.mapEvaluateOption(this.vpat_violations_sel))
        }
        this.vpat_violations_sel = null
    },
    "scat_violations_sel"() {
        if(this.$commonFuction.isEmptyObject(this.scat_violations_sel)){
            return
        }
        let check_exist = false
        for (let i = 0; i < this.scat_violations.length; i++) {
            if(this.scat_violations[i].id == this.scat_violations_sel.id){
                check_exist = true
                break
            }
        }
        if(check_exist == false){
            this.scat_violations.push(this.mapEvaluateOption(this.scat_violations_sel))
        }
        this.scat_violations_sel = null
    }
  },
  methods: {
    setRoleSra(){
        var list_sra = this.$store.getters.controllers?.list_sra ?? [];
        this.show_vpat = list_sra.includes('violation') ? true : false;
        this.show_scat = list_sra.includes('incident') ? true : false;
        this.show_diemdanh = list_sra.includes('attendance') ? true : false;
        this.show_diemdanh_edit = list_sra.includes('attendance_edit') ? true : false;
        this.show_diemdanh_deleted = list_sra.includes('attendance_delete') ? true : false;
        this.show_upd_time = list_sra.includes('attendance_update_hour') ? true : false;
        this.check_updated = list_sra.includes('update_task_status') ? true : false;
        this.show_update_execution_time = list_sra.includes('update_execution_time') ? true : false;
    },
    getDefaultAttendanceDates(){
        let now = moment().utcOffset(7)
        let start = now.clone().startOf('day').hour(8).minute(0).second(0).millisecond(0)
        let end = now.clone().startOf('day').hour(17).minute(0).second(0).millisecond(0)
        return {
            start: start.toDate(),
            end: end.toDate()
        }
    },
    mapEvaluateOption(item){
        if(!item){
            return {
                id: null,
                type: null,
                ordinal: null,
                total_count: 0,
                label: ''
            }
        }
        var label = item.label
        if(!label){
            label = item.name ?? ''
            if(item.total_count > 0){
                label += `(${item.total_count})`
            }
        }
        return {
            id: item.id,
            type: item.type,
            ordinal: item.ordinal,
            total_count: item.total_count ?? 0,
            label: label
        }
    },
    setEvaluationData(){
        let source = this.model?.sra_contractor_evaluate ?? {}
        let optionList = this.model?.sra_contractor_evaluate_options ?? []
        this.evaluation = {
            safe_value: source.safe_value ?? null,
            quality_value: source.quality_value ?? null,
            continue_value: source.continue_value ?? null,
            badge: source.badge ?? null,
            note: source.note ?? '',
            incidents: optionList.filter(item => item.type == 'incidents').map(item => this.mapEvaluateOption(item)),
            violations: optionList.filter(item => item.type == 'violations').map(item => this.mapEvaluateOption(item))
        }
    },
    hasEvaluationData(){
        return this.evaluation.safe_value != null
            || this.evaluation.quality_value != null
            || this.evaluation.continue_value != null
            || !!this.evaluation.badge
            || !!this.evaluation.note
            || this.evaluation.incidents.length > 0
            || this.evaluation.violations.length > 0
    },
    mapAttendanceRecord(user = {}, currentRecord = null){
        let date_start = currentRecord?.date_start ?? currentRecord?.date_check_in ?? currentRecord?.time_in ?? null
        let date_end = currentRecord?.date_end ?? currentRecord?.date_check_out ?? currentRecord?.time_out ?? null
        date_start = date_start ? new Date(date_start) : null
        date_end = date_end ? new Date(date_end) : null
        let working_hours = currentRecord?.working_hours ?? currentRecord?.total_hours ?? currentRecord?.hours_work ?? null
        if(working_hours != null){
            working_hours = Number(working_hours)
            if(!Number.isNaN(working_hours)){
                working_hours = Number(working_hours.toFixed(2))
            }else{
                working_hours = null
            }
        }
        let item = {
            id : currentRecord?.id ?? null,
            uid : user.uid ?? user.id ?? currentRecord?.uid ?? currentRecord?.user_id ?? null,
            fullname : user.fullname ?? currentRecord?.fullname ?? currentRecord?.user_fullname ?? '',
            username : user.username ?? currentRecord?.username ?? '',
            work_position : user.work_position ?? currentRecord?.work_position ?? '',
            updated_fullname : currentRecord?.updated_fullname ?? '',
            time : currentRecord?.time ?? (currentRecord?.updated_at ? moment(currentRecord.updated_at).format("DD/MM/YYYY HH:mm:ss") : ''),
            date_start : date_start,
            date_end : date_end,
            working_hours : working_hours
        }
        if(item.working_hours == null){
            this.updateAttendanceHours(item)
        }else{
            item.time_text = this.buildAttendanceTimeText(item)
        }
        return item
    },
    updateAttendanceCommonHours(){
        if(this.attendance_date_start && this.attendance_date_end){
            let start = new Date(this.attendance_date_start).getTime()
            let end = new Date(this.attendance_date_end).getTime()
            var attendance_working_hours = 0;
            if(!Number.isNaN(start) && !Number.isNaN(end) && end >= start){
                attendance_working_hours = Number((((end - start) / 3600000)).toFixed(2))
            }
            if(attendance_working_hours > 1){
                attendance_working_hours = attendance_working_hours - 1
            }
            this.attendance_working_hours = attendance_working_hours
        }
    },
    isFutureAttendanceDate(value){
        if(!value){
            return false
        }
        let dateValue = new Date(value).getTime()
        if(Number.isNaN(dateValue)){
            return false
        }
        return dateValue > Date.now()
    },
    validateAttendanceDateRange(startValue, endValue){
        if(!startValue || !endValue){
            return {
                valid: false,
                message: 'Vui lòng chọn đầy đủ ngày giờ vào và ngày giờ ra.'
            }
        }
        if(this.isFutureAttendanceDate(startValue) || this.isFutureAttendanceDate(endValue)){
            return {
                valid: false,
                message: 'Ngày giờ điểm danh không được lớn hơn thời gian hiện tại.'
            }
        }
        let start = new Date(startValue).getTime()
        let end = new Date(endValue).getTime()
        if(Number.isNaN(start) || Number.isNaN(end)){
            return {
                valid: false,
                message: 'Ngày giờ điểm danh không hợp lệ.'
            }
        }
        if(start >= end){
            return {
                valid: false,
                message: 'Ngày giờ vào phải nhỏ hơn ngày giờ ra.'
            }
        }
        return {
            valid: true,
            message: ''
        }
    },
    buildAttendanceTimeText(item = {}){
        let text = ''
        if(item.date_start){
            text += moment(item.date_start).format("DD/MM/YYYY HH:mm:ss")
        }
        if(item.date_end){
            text += (text ? ' - ' : '') + moment(item.date_end).format("DD/MM/YYYY HH:mm:ss")
        }
        if(item.working_hours != null && item.working_hours !== ''){
            text += (text ? ' (' : '') + Number(item.working_hours).toFixed(2) + ' giờ' + (text ? ')' : '')
        }
        return text
    },
    buildAttendanceRangeText(item = {}){
        let text = ''
        if(item.date_start){
            text += moment(item.date_start).format("HH:mm:ss DD/MM/YYYY")
        }
        if(item.date_end){
            text += (text ? ' - ' : '') + moment(item.date_end).format("HH:mm:ss DD/MM/YYYY")
        }
        return text
    },
    buildAttendanceWorkingHoursText(item = {}){
        if(item.working_hours == null || item.working_hours === ''){
            return ''
        }
        return Number(item.working_hours).toFixed(2)
    },
    updateAttendanceHours(item){
        if(item.date_start && item.date_end){
            let start = new Date(item.date_start).getTime()
            let end = new Date(item.date_end).getTime()
            if(!Number.isNaN(start) && !Number.isNaN(end) && end >= start){
                item.working_hours = Number((((end - start) / 3600000)).toFixed(2))
            }
        }
        item.time_text = this.buildAttendanceTimeText(item)
    },
    getAttendanceSourceList(){
        return this.model?.sra_attendance
            ?? this.model?.attendance_users
            ?? this.model?.attendance
            ?? this.model?.sra_attendances
            ?? []
    },
    getAttendanceEligibleUsers(){
        return this.list_tab_yc_nhansu.filter(item => item.status === 'APPROVED' && (!item.violation_status || item.violation_status === 'no'))
        // return this.list_tab_yc_nhansu
    },
    initAttendanceOptions(){
        let users = this.getAttendanceEligibleUsers().map(item => ({
            id: item.id,
            uid: item.uid,
            fullname: item.fullname,
            username: item.username,
            work_position: item.work_position,
            label: item.fullname
        }))
        this.attendance_users_obj.items = users
        this.attendance_users_obj.total = users.length
    },
    initAttendanceList(){
        let sourceList = this.getAttendanceSourceList()
        if(sourceList && sourceList.length > 0){
            let mapped = sourceList.map(item => {
                let user = this.list_tab_yc_nhansu.find(userItem => (userItem.uid && userItem.uid == (item.uid ?? item.user_id)) || userItem.id == (item.sra_users_id ?? item.id))
                return this.mapAttendanceRecord(user ?? {}, item)
            })
            this.list_tab_diemdanh = mapped
            return
        }
        this.list_tab_diemdanh = []
    },
    async listAttendance(resetOffset = false){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token){
            return
        }
        if(resetOffset == true){
            this.attendance_pagination.offset = 0
        }
        const headers = {
            "Authorization": "Bearer "+token,
        }
        let payload = {
            sra_id: this.view_id,
            offset: this.attendance_pagination.offset,
            limit: this.attendance_pagination.limit,
            company_id: this.company_id,
        }
        this.attendance_loading = true
        await ApiRepository.post("/_api/sra_attendance/list", payload, {headers}).then((response) => {
            let responseData = response.data?.data ?? {}
            let list = Array.isArray(responseData) ? responseData : (responseData.list ?? [])
            let total = Array.isArray(responseData) ? list.length : Number(responseData.total ?? 0)
            this.attendance_pagination.total = Number.isNaN(total) ? 0 : total
            this.list_tab_diemdanh = list.map(item => {
                let user = this.list_tab_yc_nhansu.find(userItem => (userItem.uid && userItem.uid == (item.uid ?? item.user_id)) || userItem.id == (item.sra_users_id ?? item.id))
                let mapped = this.mapAttendanceRecord(user ?? {}, item)
                mapped.time_text = this.buildAttendanceTimeText(mapped)
                mapped.time_range_text = this.buildAttendanceRangeText(mapped)
                mapped.working_hours_text = this.buildAttendanceWorkingHoursText(mapped)
                return mapped
            })
            if(this.list_tab_diemdanh.length == 0 && this.attendance_pagination.offset > 0 && this.attendance_pagination.total > 0){
                this.attendance_pagination.offset = Math.max(this.attendance_pagination.offset - this.attendance_pagination.limit, 0)
                this.listAttendance()
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            this.attendance_loading = false
        })
    },
    onAttendancePage(event){
        this.attendance_pagination.offset = event.first ?? 0
        this.attendance_pagination.limit = event.rows ?? this.attendance_pagination.limit
        this.attendance_loading = true
        this.list_tab_diemdanh = []
        this.listAttendance()
    },
    emitEventAttendanceUsers(keyword){
        this.$delete(this.attendance_users_obj.filters, 'keyword')
        if (keyword) {
            this.attendance_users_obj.filters.keyword = keyword
        }
        this.filterAttendanceUsers()
    },
    changeOffsetAttendanceUsers(value){
        this.attendance_users_obj.offset = value
        this.filterAttendanceUsers()
    },
    filterAttendanceUsers(){
        let keyword = this.attendance_users_obj.filters.keyword ? this.attendance_users_obj.filters.keyword.toLowerCase() : ''
        let list = this.getAttendanceEligibleUsers().filter(item => {
            if(!keyword){
                return true
            }
            let content = `${item.username ?? ''} ${item.fullname ?? ''} ${item.work_position ?? ''}`.toLowerCase()
            return content.includes(keyword)
        }).map(item => ({
            id: item.id,
            uid: item.uid,
            fullname: item.fullname,
            username: item.username,
            work_position: item.work_position,
            label: item.fullname
        }))
        this.attendance_users_obj.items = list.slice(this.attendance_users_obj.offset, this.attendance_users_obj.offset + this.attendance_users_obj.limit)
        this.attendance_users_obj.total = list.length
    },
    showAttendanceDialog(){
        this.attendance_users_obj.offset = 0
        this.attendance_users_obj.filters = {}
        this.attendance_user_sel = null
        this.initAttendanceOptions()
        let defaultDate = this.getDefaultAttendanceDates()
        this.attendance_date_start = defaultDate.start
        this.attendance_date_end = defaultDate.end
        this.attendance_working_hours = 8
        let defaultUsers = this.getAttendanceEligibleUsers().map(item => ({
            id: item.id,
            uid: item.uid,
            fullname: item.fullname,
            username: item.username,
            work_position: item.work_position,
            label: item.fullname
        }))
        this.attendance_users_sel = defaultUsers
        this.updateAttendanceCommonHours()
        this.showAttendanceModal = true
    },
    showUpdateTotalHourDialog(){
        this.sra_total_hour_input = this.sra_total_hour ?? 0
        this.showUpdateTotalHourModal = true
    },
    showUpdateExecutionTime(){
        this.execution_time_start = this.model?.date_start ? new Date(this.model.date_start) : null
        this.execution_time_end = this.model?.display_end_date ? new Date(this.model.display_end_date) : (this.model?.date_end ? new Date(this.model.date_end) : null)
        this.showUpdateExecutionTimeModal = true
    },
    editAttendance(item){
        this.attendance_edit_data = {
            id: item.id ?? null,
            fullname: item.fullname ?? '',
            date_start: item.date_start ? new Date(item.date_start) : null,
            date_end: item.date_end ? new Date(item.date_end) : null,
            working_hours: item.working_hours ?? 0
        }
        this.showAttendanceEditModal = true
    },
    updateAttendanceEditHours(){
        if(this.attendance_edit_data.date_start && this.attendance_edit_data.date_end){
            let start = new Date(this.attendance_edit_data.date_start).getTime()
            let end = new Date(this.attendance_edit_data.date_end).getTime()
            let attendance_working_hours = 0
            if(!Number.isNaN(start) && !Number.isNaN(end) && end >= start){
                attendance_working_hours = Number((((end - start) / 3600000)).toFixed(2))
            }
            if(attendance_working_hours > 1){
                attendance_working_hours = attendance_working_hours - 1
            }
            this.attendance_edit_data.working_hours = attendance_working_hours
        }
    },
    showDeleteAttendanceDialog(item){
        this.deleteAttendanceData = item
        this.showDeleteAttendanceDialogModal = true
    },
    removeAttendanceUser(index){
        this.attendance_users_sel.splice(index, 1)
    },
    async saveAttendance(){
        if(this.attendance_users_sel.length == 0){
            alert('Vui lòng chọn nhân sự điểm danh.');
            return
        }
        let attendanceValidation = this.validateAttendanceDateRange(this.attendance_date_start, this.attendance_date_end)
        if(!attendanceValidation.valid){
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: attendanceValidation.message, life: 5000 })
            return
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token){
            return
        }
        this.$commonFuction.is_loading(true);
        const headers = {
            "Authorization": "Bearer "+token,
        }
        let users = this.attendance_users_sel.map(item => ({
            sra_users_id: item.id ?? null,
            uid: item.uid ?? null,
            fullname: item.fullname ?? '',
            username: item.username ?? '',
            work_position: item.work_position ?? ''
        }))
        await ApiRepository.post("/_api/sra_attendance/save", {
            sra_id: this.view_id,
            date_start: this.attendance_date_start,
            date_end: this.attendance_date_end,
            working_hours: this.attendance_working_hours,
            users: users,
            company_id : this.company_id,
        }, {headers}).then(async (res) => {
            if(res?.data?.data?.sra_total_hour){
                this.sra_total_hour = res.data.data.sra_total_hour
                this.sra_total_hour_input = res.data.data.sra_total_hour
            }
            await this.listAttendance()
            this.showAttendanceModal = false
            this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Điểm danh thành công', life: 3000 })
        }).catch((err) => {
            console.log(err)
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
        })
        this.$commonFuction.is_loading(false);
    },
    async updateAttendance(){
        if(!this.attendance_edit_data.id){
            return
        }
        let attendanceValidation = this.validateAttendanceDateRange(this.attendance_edit_data.date_start, this.attendance_edit_data.date_end)
        if(!attendanceValidation.valid){
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: attendanceValidation.message, life: 5000 })
            return
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token){
            return
        }
        this.$commonFuction.is_loading(true);
        const headers = {
            "Authorization": "Bearer "+token,
        }
        await ApiRepository.post("/_api/sra_attendance/update", {
            id: this.attendance_edit_data.id,
            date_start: this.attendance_edit_data.date_start,
            date_end: this.attendance_edit_data.date_end,
            working_hours: this.attendance_edit_data.working_hours
        }, {headers}).then(async (res) => {
            if(res?.data?.data?.sra_total_hour){
                this.sra_total_hour = res.data.data.sra_total_hour
                this.sra_total_hour_input = res.data.data.sra_total_hour
            }
            await this.listAttendance()
            this.showAttendanceEditModal = false
            this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật điểm danh thành công', life: 3000 })
        }).catch((err) => {
            console.log(err)
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
        })
        this.$commonFuction.is_loading(false);
    },
    async updateSraTotalHour(){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token){
            return
        }
        this.$commonFuction.is_loading(true);
        const headers = {
            "Authorization": "Bearer "+token,
        }
        await ApiRepository.post("/_api/sra/update_total_hour", {
            id: this.view_id,
            company_id: this.company_id,
            sra_total_hour: this.sra_total_hour_input ?? 0
        }, {headers}).then(async () => {
            this.sra_total_hour = this.sra_total_hour_input ?? 0
            if(this.model){
                this.model.sra_total_hour = this.sra_total_hour
            }
            this.showUpdateTotalHourModal = false
            this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật số giờ làm việc thành công', life: 3000 })
        }).catch((err) => {
            console.log(err)
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
        })
        this.$commonFuction.is_loading(false);
    },
    async saveUpdateExecutionTime(){
        if(!this.execution_time_end){
            alert("Vui lòng chọn thời gian thực hiện đến!")
            return
        }
        if(this.execution_time_start && this.execution_time_end <= this.execution_time_start){
            alert("Thời gian thực hiện đến phải lớn hơn thời gian thực hiện từ!")
            return
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token){
            return
        }
        this.$commonFuction.is_loading(true);
        const headers = {
            "Authorization": "Bearer "+token,
        }
        var date_end = moment(this.execution_time_end).format("YYYY-MM-DD")
        await ApiRepository.post("/_api/sra/update_execution_time", {
            id: this.view_id,
            date_end: date_end
        }, {headers}).then(() => {
            if(this.model){
                this.model.date_end = date_end
                this.model.display_end_date = date_end
            }
            var data_date_text = ''
            if(this.model?.date_start){
                data_date_text = moment(this.model.date_start).format("DD/MM/YYYY")
            }else{
                data_date_text = '?'
            }
            data_date_text += ' - '+moment(date_end).format("DD/MM/YYYY")
            this.data_date_text = data_date_text
            this.showUpdateExecutionTimeModal = false
            this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật thời gian thực hiện thành công', life: 3000 })
        }).catch((err) => {
            console.log(err)
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err?.response?.data?.message ?? err,
                life: 3000
            });
        })
        this.$commonFuction.is_loading(false);
    },
    async deleteAttendance(){
        if(!this.deleteAttendanceData?.id){
            return
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token){
            return
        }
        this.$commonFuction.is_loading(true);
        const headers = {
            "Authorization": "Bearer "+token,
        }
        await ApiRepository.post("/_api/sra_attendance/delete", {
            id: this.deleteAttendanceData.id
        }, {headers}).then(async (res) => {
            if(res?.data?.data?.sra_total_hour){
                this.sra_total_hour = res.data.data.sra_total_hour
                this.sra_total_hour_input = res.data.data.sra_total_hour
            }
            await this.listAttendance()
            this.showDeleteAttendanceDialogModal = false
            this.deleteAttendanceData = null
            this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa điểm danh thành công', life: 3000 })
        }).catch((err) => {
            console.log(err)
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: err,
                life: 3000
            });
        })
        this.$commonFuction.is_loading(false);
    },
    async UpdateListDoanhNghiep(list=[]){
        var list_tmp = []
        var count_title = 0;
        for (let i = 0; i < list.length; i++) {
            let e = list[i];
            e.stt = i+1;
            let status_html = ''
            let show_edit_contractor = false
            if(e.status == 'NEEDS_UPDATE'){
                status_html = '<span style="color:#333333">Cần cập nhật</span>'
                show_edit_contractor = true
            }else if(e.status == 'WAITTING'){
                status_html = '<span style="color:#333333">Chờ duyệt</span>'
            }else if(e.status == 'APPROVED'){
                count_title ++;
                status_html = '<span class="status-approved">Đã duyệt</span>'
            }else if(e.status == 'REJECTED'){
                status_html = '<span class="status-rejected">Bị từ chối</span>'
                show_edit_contractor = true
            }
            if(this.$store.getters.typeCompany !== 'contractor'){
                show_edit_contractor = true
            }
            e.status_html = status_html
            e.show_edit_contractor = show_edit_contractor
            let time = ''
            if(e.date_update){
                time = moment(e.updated_at).format("DD/MM/YYYY HH:mm:ss")
            }
            e.time = time
            list_tmp.push(e)
        }
        // console.log("list_tmp==",list_tmp)
        this.list_tab_yc_contractor = list_tmp
        console.log("count_title",count_title)
        if(count_title > 0){
            this.name_tab[1] = 'Cập nhật hồ sơ nhà thầu ('+count_title+')'
        }
    },
    async listYcDoanhNghiep(){
        // console.log("typeCompany==",this.$store.getters.typeCompany)
        // console.log("roleCompany==",this.$store.getters.roleCompany)
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            var {data} = await ApiRepository.post("/_api/sra/list_profile_contractor", {id: this.view_id, company_id: this.company_id}, {headers});
            var value = data.data;
            if(value.length > 0){
                this.UpdateListDoanhNghiep(value)
            }else{
                this.UpdateListDoanhNghiep([])
            }
        }
    },
    async getYcVatTu(sra_files_supplies){
        var html = ''
        if(sra_files_supplies && sra_files_supplies.length > 0){
            for (let i = 0; i < sra_files_supplies.length; i++) {
                const e = sra_files_supplies[i];
                if(e.document_files_id){
                    html+=`<div class="pad-cus">`+e.name+`</div>`
                }else{//khác
                    html+=`<div class="pad-cus container-tpl-vt">
                    <div class="cl-other">Khác - </div><div>`+e.name+`</div></div>`
                }
            }
        }
        this.yc_vattu = html
    },
    async getYcThietBi(sra_files_equipment){
        var html = ''
        if(sra_files_equipment && sra_files_equipment.length > 0){
            for (let i = 0; i < sra_files_equipment.length; i++) {
                const e = sra_files_equipment[i];
                if(e.document_files_id){
                    html+=`<div class="pad-cus">`+e.name+`</div>`
                }else{//khác
                    html+=`<div class="pad-cus container-tpl-vt">
                    <div class="cl-other">Khác - </div><div>`+e.name+`</div></div>`
                }
            }
        }
        this.yc_thietbi = html
    },
    async getYcNhanSu(sra_files_users,sra_course){
        var html = ''
        if(sra_files_users && sra_files_users.length > 0){
            for (let i = 0; i < sra_files_users.length; i++) {
                const e = sra_files_users[i];
                if(e.document_files_id){
                    html+=`<div class="pad-cus">`+e.name+`</div>`
                }else{//khác
                    html+=`<div class="pad-cus container-tpl-vt">
                    <div class="cl-other">Khác - </div><div>`+e.name+`</div></div>`
                }
            }
        }
        //khóa đào tạo
        // html+=`<div class="pad-cus" style="font-weight: bold;">KHÓA ĐÀO TẠO</div>`
        // if(sra_course.length > 0){
        //     for (let i = 0; i < sra_course.length; i++) {
        //         const sc = sra_course[i];
        //         if(sc.course && sc.course.name){
        //             html+=`<div class="pad-cus">`+sc.course.name+`</div>`
        //         }
        //     }
        // }
        var html_kdt = ''
        if(sra_course && sra_course.length > 0){
            for (let i = 0; i < sra_course.length; i++) {
                const sc = sra_course[i];
                if(sc.course && sc.course.name){
                    html_kdt+=`<div class="pad-cus">`+sc.course.name+`</div>`
                }
            }
        }
        this.yc_nhansu = html
        this.yc_kdt = html_kdt
    },
    async getYcDoanhNghiep(sra_files_contractor){
        var html = ''
        if(sra_files_contractor && sra_files_contractor.length > 0){
            for (let i = 0; i < sra_files_contractor.length; i++) {
                const e = sra_files_contractor[i];
                if(e.document_files_id){
                    html+=`<div class="pad-cus">`+e.name+`</div>`
                }else{//khác
                    html+=`<div class="pad-cus container-tpl-vt">
                    <div class="cl-other">Khác - </div><div>`+e.name+`</div></div>`
                }
            }
        }
        this.yc_doanhnghiep = html
    },
    async getStatus(status,uid_c1=null,uid_c2=null,created_by=null){
        if(status !== 'NEW' && status !== 'APPROVED_LV1' && status !== 'REJECTED'){
            this.hideTab = 0
        }
        this.status = status;
        var text = ''
        var type_login = this.$store.getters.type ? this.$store.getters.type : null;
        
        if(status == 'NEW'){ 
            text = 'Mới'
            this.show_cancel = true
            let show_approved = false
            let show_edit = false
            if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
                show_approved = true;
                show_edit = true
            }
            if(created_by == this.$store.getters.user){
                show_edit = true;
            }
            if(uid_c1 && uid_c1 == this.$store.getters.user){
                show_approved = true; 
            }
            if(uid_c2 == this.$store.getters.user){
                this.show_cancel = false;
            }
            
            this.show_edit = show_edit
            this.show_approved = show_approved
        }
        else if(status == 'APPROVED_LV1'){
            text = 'Đã duyệt cấp 1'
            let show_approved = false
            if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
                show_approved = true;
            }else {
                if(uid_c2 && uid_c2 == this.$store.getters.user){
                    show_approved = true; 
                }
            }
            this.show_approved = show_approved
        }
        else if(status == 'APPROVED'){text = 'Đã duyệt'}
        else if(status == 'REJECTED'){
            let show_cancel = false
            let show_edit = false
            if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
                show_cancel = true;
                show_edit = true;
            }
            if(created_by && created_by == this.$store.getters.user){
                show_cancel = true; 
                show_edit = true
            }
            text = 'Bị từ chối'
            this.show_cancel = show_cancel
            this.show_edit = show_edit
        }
        else if(status == 'CLOSE'){text = 'Đã đóng'}
        else if(status == 'CANCEL'){text = 'Đã hủy'}
        this.status_text = text
    },
    async getData(id) {
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
            "Authorization": "Bearer "+token,
            };
            var {data} = await ApiRepository.post("/_api/sra/view_detail", {id: id, company_id: this.company_id}, {headers});
            var value = data.data;
            this.model = value;
        }
    },
    showContent(index){
        this.currentTab = index
    },
    backToList(){
        this.$router.push({ path: '/admin/list-sra', query: {company_id: this.company_id} });
    },
    showCancel(){
        this.showCancelDialog = true;
    },
    goEdit(){
        this.$router.push({ path: '/admin/list-sra/edit/'+this.view_id, query: {company_id: this.company_id} });
    },
    toggleIcon(key){
      if(key == 1){
        this.show_1 = !this.show_1
      }else if(key == 2){
        this.show_2 = !this.show_2
      }else if(key == 3){
        this.show_3 = !this.show_3
      }
    },
    showApproved(){
        this.infoApproved = {
            status : 'APPROVED',
            note : ''
        },
        this.showApproveDialog = true;
    },
    clickApprove(){
      this.infoApproved.status = "APPROVED"
      this.infoApproved.note = ""
    },
    clickReject(){
      this.infoApproved.status = "REJECTED"
    },
    async updateStatus(status,note=''){
        this.$commonFuction.is_loading(false);
        var objects = {
            id : this.view_id,
            status : status,
            note : note,
        }
        var that = this;
        var company_id = this.company.id ? this.company.id : null;
        objects.company_id = company_id
        var token = that.$store.getters.token ? that.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            }; 
            await ApiRepository.post("/_api/sra/update_status", objects, {headers}).then(async function (response) {
                if (response.status === 200) {
                    that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
                    that.$commonFuction.is_loading(false);
                    that.reloadPage();
                }
            }).catch((err) => {
                if(err.response && err.response.data){
                    if(err.response.data.message == "CAN_NOT_UPDATE_STATUS"){
                        that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: "Lỗi cập nhật trạng thái!",
                        life: 3000
                        });
                    }
                    }else{
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }
                that.$commonFuction.is_loading(false);
            })
        }
    },
    reloadPage(){
        window.location.reload();
    },
    updateStatusSel(){
        if(!this.infoApproved.status){
            alert('Vui lòng chọn trạng thái duyệt.');
            return;
        }
        if(this.infoApproved.status=='REJECTED' && !this.infoApproved.note){
            alert('Vui lòng nhập lý do từ chối.');
            return;
        }
        this.updateStatus(this.infoApproved.status,this.infoApproved.note)
    },
    viewNote(){
        this.showRejectNote = true
    },
    goPageAdd(key){
        console.log("key add",key)
        if(key == 'supplies_equipment'){
            key = 'equipment' //gán key ban đầu là thiết bị
        }
        //http://localhost:8080/admin/list-sra/data/add
        this.$router.push({ path: '/admin/list-sra/detail/'+this.view_id, query: {company_id: this.company_id,tp:'add',k:key} });
    },
    goPageEdit(key,data = null){
        if(key == 'user'){
            this.$router.push({ path: '/admin/list-sra/detail/'+this.view_id, query: {company_id: this.company_id,tp:'edit',k:key,su_id:data.id} });
        }else if(key == 'supplies_equipment'){
            if(data.type == 'equipment'){
                key = 'equipment' //gán key ban đầu là thiết bị
            }else if(data.type == 'supplies'){
                key = 'supplies' //gán key ban đầu là vật tư
            }
            this.$router.push({ path: '/admin/list-sra/detail/'+this.view_id, query: {company_id: this.company_id,tp:'edit',k:key,sse_id:data.id} });
        }else{
            this.$router.push({ path: '/admin/list-sra/detail/'+this.view_id, query: {company_id: this.company_id,tp:'edit',k:key} });
        }
        
    },
    goPageView(key,data = null){
        if(key == 'user'){
            this.$router.push({ path: '/admin/list-sra/detail/'+this.view_id, query: {company_id: this.company_id,tp:'view',k:key,su_id:data.id} });
        }
    },
    async downloadFiles(files) {
      if (!files || files.length === 0) return;

      this.loading_download = true; // bật spinner

      try {
        if (files.length === 1) {
          // tải trực tiếp
          const file = files[0];
          const a = document.createElement("a");
          a.href = file.url || file.objectURL;
          a.download = file.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          // nén zip
          const zip = new JSZip();
          const folder = zip.folder("downloads");

          for (const file of files) {
            const response = await fetch(file.url || file.objectURL);
            const blob = await response.blob();
            folder.file(file.name, blob);
          }

          const content = await zip.generateAsync({ type: "blob" });
          saveAs(content, "download_files.zip");
        }
      } catch (e) {
        console.error("Lỗi tải file:", e);
      } finally {
        this.loading_download = false; // tắt spinner
      }
    },
    async viewFile(file) {
      const fileUrl = file ? (file.url || file.objectURL) : null;
      if (!fileUrl) return;

      const fileName = file.name || fileUrl.split("?")[0].split("/").pop() || "";
      const extension = fileName.toLowerCase().split(".").pop();
      const imageMimeTypes = {
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",
        webp: "image/webp",
        bmp: "image/bmp",
        svg: "image/svg+xml",
        tif: "image/tiff",
        tiff: "image/tiff",
      };
      const isPdf = extension === "pdf";
      const isImage = Object.prototype.hasOwnProperty.call(imageMimeTypes, extension);

      if (!isPdf && !isImage) {
        window.open(fileUrl, "_blank", "noopener,noreferrer");
        return;
      }

      const previewWindow = window.open("", "_blank");
      if (!previewWindow) {
        alert("Vui lòng cho phép trình duyệt mở cửa sổ mới để xem file.");
        return;
      }

      previewWindow.opener = null;
      this.loading_download = true;

      try {
        const response = await fetch(fileUrl);
        if (!response.ok) {
          throw new Error(`Không thể tải file (${response.status})`);
        }

        const blob = await response.blob();
        const previewMimeType = isPdf ? "application/pdf" : imageMimeTypes[extension];
        const previewBlob = blob.type === previewMimeType
          ? blob
          : new Blob([blob], { type: previewMimeType });
        const blobUrl = URL.createObjectURL(previewBlob);

        previewWindow.location.href = blobUrl;
        const cleanupInterval = window.setInterval(() => {
          if (previewWindow.closed) {
            window.clearInterval(cleanupInterval);
            URL.revokeObjectURL(blobUrl);
          }
        }, 5000);//tab sau khi đóng 5s sẽ giải phóng bộ nhớ
      } catch (e) {
        previewWindow.close();
        console.error("Lỗi xem file:", e);
        alert("Không thể mở file. Máy chủ lưu file có thể chưa cho phép truy cập CORS.");
      } finally {
        this.loading_download = false;
      }
    },
    async listYcNhanSu(){
        this.check_all = false
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            var {data} = await ApiRepository.post("/_api/sra/list_profile_user", {id: this.view_id, company_id: this.company_id}, {headers});
            var value = data.data;
            // console.log("value==",value)
            if(value.length > 0){
                this.UpdateListNhanSu(value)
            }else{
                this.UpdateListNhanSu([])
            }
        }
    },
    async exportExcelNhanSu(){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token || this.exporting_excel){
            return
        }
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.exporting_excel = true
        this.$commonFuction.is_loading(true);
        try{
            // api trả về path file trước, sau đó 3s gọi check 1 lần cho tới khi file export xong
            var {data} = await ApiRepository.post("/_api/sra/export_profile_user", {id: this.view_id, company_id: this.company_id}, {headers});
            var path = data.data ? data.data.path : null
            if(!path){
                throw new Error('no path')
            }
            var finished = false
            while(!finished){
                await new Promise(resolve => setTimeout(resolve, 3000))
                var res = await ApiRepository.post("/_api/sra/check_export_file", {path: path, company_id: this.company_id}, {headers});
                var result = res.data.data ?? {}
                if(result.status == 'done'){
                    finished = true
                    // tải file về luôn, không mở tab mới
                    var link = document.createElement('a')
                    link.href = result.linkExcel
                    link.download = ''
                    link.style.display = 'none'
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }else if(result.status == 'error'){
                    throw new Error('export error')
                }
            }
        }catch(e){
            console.error("Lỗi xuất excel:", e)
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Xuất file excel thất bại', life: 5000 })
        }finally{
            this.$commonFuction.is_loading(false);
            this.exporting_excel = false
        }
    },
    async UpdateListNhanSu(list=[]){
        var list_tmp = []
        var count_title = 0
        for (let i = 0; i < list.length; i++) {
            let e = list[i];
            // console.log("e==",e)
            if(e.company_type !== 'option_1'){
                // console.log("aadad")
                e.stt = i+1;
            }
            let status_html = ''
            let show_edit = true
            let time_text = ''
            if(e.status == 'WAITTING'){
                status_html = '<span style="color:#333333">Chờ duyệt</span>'
                show_edit = false
            }else if(e.status == 'APPROVED'){
                count_title++
                status_html = '<span class="status-approved">Đã duyệt</span>'
                show_edit = false
            }else if(e.status == 'REJECTED'){
                status_html = '<span class="status-rejected">Bị từ chối</span>'
            }
            e.status_html = status_html
            e.show_edit = show_edit
            let d_tc_yc = ''
            if(e.total_status){
                d_tc_yc += e.total_status.d ?? '0';
                d_tc_yc += '/'+e.total_status.tc ?? '0';
                d_tc_yc += '/'+e.total_status.total ?? '0';
            }
            e.d_tc_yc = d_tc_yc
            let time = ''
            if(e.updated_at){
                time = moment(e.updated_at).format("DD/MM/YYYY HH:mm:ss")
            }
            e.time = time
            e.active_check = false
            let download_gp = false
            if(e.sra_entrance_permit && e.sra_entrance_permit.length > 0){
                let m = e.sra_entrance_permit[0]
                if(m.date_start && m.date_end){
                    time_text = moment(m.date_start).format("DD/MM/YYYY")+' - '+moment(m.date_end).format("DD/MM/YYYY")
                }
                download_gp = true
            }
            e.download_gp = download_gp
            // tài khoản không hoạt động và chưa có giấy vào cổng thì hiển thị màu xám
            e.inactive_user = e.user_active === false && !download_gp
            e.time_text = time_text
            let total = 0;
            let pass = 0;
            if(e.sra_course_lesson_users && e.sra_course_lesson_users.length > 0){
                total = e.sra_course_lesson_users.length
                for (let j = 0; j < e.sra_course_lesson_users.length; j++) {
                    let e1 = e.sra_course_lesson_users[j];
                    if(e1.status == 'PASS'){
                        pass++
                    }
                }
            }
            let course_text = pass+'/'+total
            if(total == 0 && e.status=='APPROVED'){
                course_text = 'Không có lớp học nào'
            }
            e.course_text = course_text

            let violation_status_html = ''
            if(e.violation_status == 'no' || e.violation_status == null){
                violation_status_html = '<span class="status-approved">Không</span>'
            }else if(e.violation_status == 'banned'){
                violation_status_html = '<span class="status-rejected">Vi phạm</span>'
            }
            e.violation_status_html = violation_status_html
            e.total_violation = Number(e.total_violation ?? 0)
            e.total_incident = Number(e.total_incident ?? 0)

            let last_time_attendance = ''
            if(e.attendance_last_time) {
                last_time_attendance = moment(e.attendance_last_time).format("DD/MM/YYYY HH:mm:ss")
            }
            e.last_time_attendance = last_time_attendance
            list_tmp.push(e)
        }
        // console.log("list_tmp==",list_tmp)
        this.list_tab_yc_nhansu = list_tmp
        if(count_title > 0){
            this.name_tab[2] = 'Cập nhật nhân sự ('+count_title+')'
        }
        if(this.company_type == 'option_1'){
            this.initAttendanceOptions()
            await this.listAttendance()
        }
    },
    async listYcKhoaDaoTao(){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {"Authorization": "Bearer "+token};
            var {data} = await ApiRepository.post("/_api/sra/list_profile_course", {id: this.view_id, company_id: this.company_id}, {headers});
            var value = data.data;
            if(value.length > 0){
                this.UpdateListKhoaDaoTao(value)
            }else{
                this.UpdateListKhoaDaoTao([])
            }
        }
    },
    async UpdateListKhoaDaoTao(list=[]){
        var list_tmp = []
        var check_show_link = false
        if (this.$store.getters.controllers?.list_course && this.$store.getters.controllers?.list_course.includes('view')) {
            check_show_link = true
        }
        for (let i = 0; i < list.length; i++) {
            let e = list[i];
            var link_course = '/admin/list-course/view/'+e.course_id+'?lesson_id='+e.id+'&company_id='+this.company.id
            e.stt = i+1;
            //<span style="color:#333333">Cần cập nhật</span>
            e.name_html = `<span>`+e.course_name+`</span>`
            if(check_show_link == true){
                if(e.course_type == 'online'){
                    link_course = this.$ConfigEvn.base_url_khoa_hoc+`/`+this.$constants.URL_KHOA_HOC.VIEW_KHOA_HOC+'/'+e.map_id
                    e.name_html = `<a style="text-decoration:underline" target="_blank" href="`+link_course+`">`+e.course_name+`</a>`
                }else{
                    e.name_html = `<a style="text-decoration:underline" href="`+link_course+`">`+e.course_name+`</a>`
                }
                
            }
            if(e.course_type == 'online'){
                e.type_text = 'Online'
            }else{
                e.type_text = 'Offline'
            }
            e.time = e.date_update ? moment(e.date_update).format("DD/MM/YYYY HH:mm:ss") : ''
            let lesson_text = ''
            if(e.sra_course_lesson_users && e.sra_course_lesson_users.length > 0){
                let total = 0;
                let pass = 0;
                for (let j = 0; j < e.sra_course_lesson_users.length; j++) {
                    let e1 = e.sra_course_lesson_users[j];
                    if(e1.status == 'PASS'){
                        pass++
                    }
                    total++
                }
                lesson_text = pass+'/'+total
            }
            e.lesson_text = lesson_text
            e.link_course = link_course
            list_tmp.push(e)
        }
        // console.log("list_tmp==",list_tmp)
        this.list_tab_kdt = list_tmp
    },
    showAddLessonDialog(){
        this.title_kdt = 'Thêm khóa đào tạo'
        this.info_course = {
            id : null,
            time_text : '',
            address : '',
            files : [],
        }
        this.sra_course = null
        this.showUpdateLesson = true
        //gọi lấy danh sách khóa học
        this.getListSraCourse();
    },
    showUpdateLessonDialog(index){
        this.title_kdt = 'Cập nhật khóa đào tạo'
        this.filesDeletes2_tmp = []
        var tmp = this.list_tab_kdt[index]
        // console.log("tmp==",tmp)
        this.sra_course = {
            id : tmp.sra_course_id,
            name : tmp.course_name,
            type : tmp.course_type,
        }
        this.info_course = {
            id : tmp.id,
            time_text : tmp.time_text,
            address : tmp.address,
            files : tmp.files ? JSON.parse(JSON.stringify(tmp.files)) : [],
        }
        this.showUpdateLesson = true
    },
    emitEventListSraCourse(keyword) {
      console.log(keyword);
      this.$delete(this.sra_course_obj.filters, 'name');
      if (keyword) {
        this.sra_course_obj.filters.name = keyword;
      }
      this.getListSraCourse();
    },
    changeOffsetListSraCourse(value) {
      this.sra_course_obj.offset = value;
    },
    async getListSraCourse() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.sra_course = null,
        this.sra_course_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.sra_course_obj.loading = true;
        await ApiRepository.post("/_api/sra/list_sra_course", {sra_id : this.view_id,filters: this.sra_course_obj.filters, limit: this.sra_course_obj.limit, offset: this.sra_course_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.sra_course_obj.offset > 0 ) {
              this.sra_course_obj.items.push(...res.data.data.sra_course);
            } else{
              this.sra_course_obj.items = res.data.data.sra_course;
            }
            this.sra_course_obj.total = res.data.data.count;
            this.sra_course_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.sra_course_obj.loading = false;
        })
      }
    },
    showSuccess(){
        this.listYcKhoaDaoTao();
        this.$commonFuction.is_loading(false);
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
        this.showUpdateLesson = false
    },
    showDelete(){
        this.listYcKhoaDaoTao();
        this.$commonFuction.is_loading(false);
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        this.showDeleteDialog = false
    },
    async UpdateLesson(){
        this.$commonFuction.is_loading(true);
        // this.$commonFuction.is_loading(false);
        //k phải object
        if(this.$commonFuction.isEmptyObject(this.sra_course) || this.$commonFuction.isEmpty(this.sra_course)){
            alert('Vui lòng chọn khóa đào tạo.');
            this.$commonFuction.is_loading(false);
            return;
        }
        if(this.sra_course.type == 'offline'){
            if(this.$commonFuction.isEmpty(this.info_course.time_text)){
                alert('Vui lòng nhập thời gian học.');
                this.$commonFuction.is_loading(false);
                return;
            }
            if(this.$commonFuction.isEmpty(this.info_course.address)){
                alert('Vui lòng nhập địa điểm học.');
                this.$commonFuction.is_loading(false);
                return;
            }
        }
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }

        var object = {
            sra_course : this.sra_course,
            info_course : this.info_course,
            company_id : this.company.id,
            files_deleted : this.filesDeletes2_tmp,
        }
        var that = this;
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            await ApiRepository.post("/_api/sra/update_sra_course", object, {headers}).then((response) => {
                if (response.status === 200) {
                    that.showSuccess();
                } else {
                that.$toast.add({ 
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: response.data.message,
                    life: 3000
                });
                that.$commonFuction.is_loading(false);
                }
            }).catch((err) => {
                console.log(err);
                that.$toast.add({ 
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: err,
                    life: 3000
                });
                that.$commonFuction.is_loading(false);
            })
        }
    },
    showDeletedDialog(index){
        var tmp = this.list_tab_kdt[index]
        this.deleteData = {
            id : tmp.id,
            name : tmp.course_name,
        }
        this.showDeleteDialog = true;
    },
    async deleteDataCourse(){
        this.$commonFuction.is_loading(true);
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        var object = {
            id : this.deleteData.id,
            name : this.deleteData.name,
            company_id : this.company.id
        }
        var that = this;
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            await ApiRepository.post("/_api/sra/deleted_sra_course", object, {headers}).then((response) => {
                if (response.status === 200) {
                    that.showDelete();
                } else {
                    that.$toast.add({ 
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: response.data.message,
                        life: 3000
                    });
                    that.$commonFuction.is_loading(false);
                }
            }).catch((err) => {
                console.log(err);
                if(err.response && err.response.data){
                    if(err.response.data.message == "CAN_NOT_DELETE"){
                        that.$toast.add({
                            severity: 'error',
                            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                            detail: "Lớp đã có nhân sự được kết quả Đạt trong lớp!",
                            life: 5000
                        });
                    }else{
                        that.$toast.add({
                            severity: 'error',
                            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                            detail: err,
                            life: 3000
                        });
                    }
                }else{
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }
                
                that.$commonFuction.is_loading(false);
            })
        }
    },
    async listYcVatTuThietBi(){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {"Authorization": "Bearer "+token};
            var {data} = await ApiRepository.post("/_api/sra/list_supplies_equipment", {id: this.view_id, company_id: this.company_id}, {headers});
            var value = data.data;
            console.log("value==",value)
            if(value.length > 0){
                this.UpdateListVatTuThietBi(value)
            }else{
                this.UpdateListVatTuThietBi([])
            }
        }
    },
    async UpdateListVatTuThietBi(list=[]){
        var list_tmp = []
        var count_title = 0
        for (let i = 0; i < list.length; i++) {
            let e = list[i];
            e.stt = i+1;
            let type_text = ''
            let show_edit = true
            if(e.type == 'supplies'){
                type_text = 'Vật tư'
            }else if(e.type == 'equipment'){
                type_text = 'Thiết bị'
            }
            let status_html = ''
            if(e.status == 'WAITTING'){
                show_edit = false
                status_html = '<span style="color:#333333">Chờ duyệt</span>'
            }else if(e.status == 'APPROVED'){
                show_edit = false
                count_title++
                status_html = '<span class="status-approved">Đã duyệt</span>'
            }else if(e.status == 'REJECTED'){
                status_html = '<span class="status-rejected">Bị từ chối</span>'
            }
            e.type_text = type_text
            e.status_html = status_html
            e.show_edit = show_edit
            let d_tc_yc = ''
            let list_file = []
            if(e.total_status){
                d_tc_yc += e.total_status.d ?? '0';
                d_tc_yc += '/'+e.total_status.tc ?? '0';
                d_tc_yc += '/'+e.total_status.total ?? '0';
                list_file = e.total_status.list_file ?? []
            }
            e.d_tc_yc = d_tc_yc
            e.list_file = list_file
            let time = ''
            if(e.updated_at){
                time = moment(e.updated_at).format("DD/MM/YYYY HH:mm:ss")
            }
            e.time = time
            list_tmp.push(e)
        }
        this.list_tab_yc_vttb = list_tmp
        if(count_title > 0){
            this.name_tab[4] = 'Cập nhật vật tư & thiết bị ('+count_title+')'
        }
    },
    changeSelectRowAll(){
        for (let i = 0; i < this.list_tab_yc_nhansu.length; i++) {
            if(this.check_all == true){
                this.list_tab_yc_nhansu[i].active_check = true
            }else{
                this.list_tab_yc_nhansu[i].active_check = false
            }
        }
    },
    changeSelectRow(){
        var count = this.list_tab_yc_nhansu.length
        var count_check = 0
        for (let i = 0; i < this.list_tab_yc_nhansu.length; i++) {
            if(this.list_tab_yc_nhansu[i].active_check == true){
                count_check++
            }
        }
        if(count == count_check){
            this.check_all = true
        }else{
            this.check_all = false
        }
    },
    async ViPhamAnToan(){
        this.select_nscheck = []
        this.banned_reason = 'Vi phạm an toàn'
        this.vpat_violations = []
        this.vpat_date = new Date()
        this.vpat_violations_sel = null
        this.vpat_violations_obj.offset = 0
        this.vpat_violations_obj.filters = {}
        this.vpat_violations_obj.items = []
        this.vpat_violations_obj.total = 0
        this.ep_fullname = ''
        var ep_fullname = ''
        for (let i = 0; i < this.list_tab_yc_nhansu.length; i++) {
            let e = this.list_tab_yc_nhansu[i]
            if(e.active_check == true){
                if(e.violation_status !== 'no'){
                    alert('Vui lòng chọn nhân sự đang làm.');
                    this.select_nscheck = []
                    return
                }
                this.select_nscheck.push({
                    id : e.uid,
                    fullname : e.fullname,
                    sra_users_id : e.id
                })
                if(ep_fullname == ''){
                    ep_fullname = e.fullname
                }else if(ep_fullname != ''){
                    ep_fullname += '; '+e.fullname
                }
            }
        }
        if(this.select_nscheck.length == 0){
            alert('Vui lòng chọn nhân sự cấm vào.');
            return;
        }
        this.ep_fullname = ep_fullname
        await this.getVPATViolations()
        this.showVPATDialog = true
    },
    async capGiayEP(){
        this.ep_areas_sel = null
        this.is_load_data = true
        this.select_nscheck = []
        this.ep_fullname = ''
        this.ep_data_date = []
        var ep_fullname = ''
        for (let i = 0; i < this.list_tab_yc_nhansu.length; i++) {
            let e = this.list_tab_yc_nhansu[i]
            if(e.active_check == true){
                if(e.status !== 'APPROVED'){
                    alert('Vui lòng chọn nhân sự đã được duyệt.');
                    this.select_nscheck = []
                    return
                }
                if(e.user_active === false && !e.download_gp){//tài khoản không hoạt động và chưa có giấy vào cổng
                    alert('Có nhân sự không được phép cấp giấy ra vào cổng.');
                    this.select_nscheck = []
                    return
                }
                this.select_nscheck.push({
                    id : e.uid,
                    fullname : e.fullname,
                    sra_users_id : e.id
                })
                if(ep_fullname == ''){
                    ep_fullname = e.fullname
                }else if(ep_fullname != ''){
                    ep_fullname += '; '+e.fullname
                }
            }
        }
        if(this.select_nscheck.length == 0){
            alert('Vui lòng chọn nhân sự.');
            return;
        }
        this.ep_factory = this.factory
        this.ep_areas = this.areas
        this.ep_fullname = ep_fullname
        
        await this.getListFactory()
        this.getListAreas()
        this.showEPDialog = true
        this.is_load_data = false
    },
    showDeletedDialogNS(data){
        this.deleteDataNS = {
            id : data.id,
            uid : data.uid,
            fullname : data.fullname,
        }
        this.showDeleteDialogNS = true;
    },
    async deleteDataNSu(){
        this.$commonFuction.is_loading(true);
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        var object = {
            id : this.deleteDataNS.id,
            uid : this.deleteDataNS.uid,
            name : this.deleteDataNS.name,
            company_id : this.company.id
        }
        var that = this;
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            await ApiRepository.post("/_api/sra/deleted_sra_users", object, {headers}).then((response) => {
                if (response.status === 200) {
                    that.showDeleteNS();
                } else {
                    that.$toast.add({ 
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: response.data.message,
                        life: 3000
                    });
                    that.$commonFuction.is_loading(false);
                }
            }).catch((err) => {
                console.log(err);
                if(err.response && err.response.data){
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }else{
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }
                that.$commonFuction.is_loading(false);
            })
        }
    },
    showDeleteNS(){
        this.listYcNhanSu();
        this.$commonFuction.is_loading(false);
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        this.showDeleteDialogNS = false
    },
    showDeletedDialogVTTB(data){
        console.log("data==",data)
        this.deleteDataVTTB = {
            id : data.id,
        }
        this.showDeleteDialogVTTB = true;
    },
    async deleteDataVTTBi(){
        this.$commonFuction.is_loading(true);
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        var object = {
            id : this.deleteDataVTTB.id,
            company_id : this.company.id
        }
        var that = this;
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            await ApiRepository.post("/_api/sra/deleted_sra_supplies_equipment", object, {headers}).then((response) => {
                if (response.status === 200) {
                    that.showDeleteVTTB();
                } else {
                    that.$toast.add({ 
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: response.data.message,
                        life: 3000
                    });
                    that.$commonFuction.is_loading(false);
                }
            }).catch((err) => {
                console.log(err);
                if(err.response && err.response.data){
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }else{
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }
                that.$commonFuction.is_loading(false);
            })
        }
    },
    showDeleteVTTB(){
        this.listYcVatTuThietBi();
        this.$commonFuction.is_loading(false);
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        this.showDeleteDialogVTTB = false
    },
    emitEventListFactory(keyword) {
      // console.log(keyword);
      this.$delete(this.ep_factory_obj.filters, 'name');
      if (keyword) {
        this.ep_factory_obj.filters.name = keyword;
      }
      this.getListFactory();
    },
    async getListFactory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.ep_factory_obj.loading = true;
        await ApiRepository.post("/_api/factory/options", {filters: this.ep_factory_obj.filters, limit: this.ep_factory_obj.limit, offset: this.ep_factory_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.ep_factory_obj.offset > 0 ) {
            this.ep_factory_obj.items.push(...res.data.data.factory);
          } else{
            this.ep_factory_obj.items = res.data.data.factory;
          }
          this.ep_factory_obj.total = res.data.data.count;
          this.ep_factory_obj.loading = false;
        }).catch((err) => {
          console.log(err);
          this.ep_factory_obj.loading = false;
        })
      }
    },
    emitEventListAreas(keyword) {
        // console.log(keyword);
        // console.log("dasdasdasd")
        this.$delete(this.ep_areas_obj.filters, 'name');
        if (keyword) {
            this.ep_areas_obj.filters.name = keyword;
        }
        this.getListAreas();
    },
    async getListAreas() {
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        var factory_id = this.ep_factory?.id ?? null;
        if(!factory_id){
            return;
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            }
            this.ep_areas_obj.loading = true;
            await ApiRepository.post("/_api/area/options", {filters: this.ep_areas_obj.filters, limit: this.ep_areas_obj.limit, offset: this.ep_areas_obj.offset, company_id: this.company.id ,factory_id : factory_id}, {headers}).then((res) => {
                let data_option = [];
                res.data.data.area.map(m=>{
                    data_option.push({id: m.id ,name: m.name})
                })
                // console.log("data_option",data_option)
                if (this.ep_areas_obj.offset > 0 ) {
                    this.ep_areas_obj.items.push(...data_option);
                } else{
                    this.ep_areas_obj.items = data_option;
                }
                this.ep_areas_obj.total = res.data.data.count;
                this.ep_areas_obj.loading = false;
            }).catch((err) => {
                console.log(err);
                this.ep_areas_obj.loading = false;
            })
        }
    },
    async approvedCapGiayEP(){
        if(!this.ep_data_date[0] || !this.ep_data_date[1]){
            alert('Vui lòng chọn thời gian hiệu lực.');
            return;
        }
        if(!this.ep_factory){
            alert('Vui lòng chọn nhà máy.');
            return;
        }
        if(this.$commonFuction.isEmpty(this.ep_areas) || this.ep_areas.length == 0 || this.$commonFuction.isEmptyObject(this.ep_areas)){
            alert('Vui lòng chọn khu vực.');
            return;
        }
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        this.$commonFuction.is_loading(true);
        var time = [
            moment(this.ep_data_date[0]).format("YYYY-MM-DD"),
            moment(this.ep_data_date[1]).format("YYYY-MM-DD"),
        ]
        var object ={
            id : this.view_id,
            users : this.select_nscheck,
            time : time,
            factory : this.ep_factory,
            areas : this.ep_areas,
            company_id : this.company.id
        }
        var that = this;
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            await ApiRepository.post("/_api/sra/entrance_permit", object, {headers}).then((response) => {
                if (response.status === 200) {
                    that.loadNhanSu();
                } else {
                    that.$toast.add({ 
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: response.data.message,
                        life: 3000
                    });
                    that.$commonFuction.is_loading(false);
                }
            }).catch((err) => {
                console.log(err);
                if(err.response && err.response.data){
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }else{
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }
                
                that.$commonFuction.is_loading(false);
            })
        }
        this.$commonFuction.is_loading(false);
    },
    async approvedVPAT(){
        if(this.vpat_violations.length == 0){
            alert('Vui lòng chọn vi phạm an toàn.');
            return;
        }
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        this.$commonFuction.is_loading(true);
        this.banned_reason = this.vpat_violations.map(item => item.label).join('; ')
        var object ={
            id : this.view_id,
            users : this.select_nscheck,
            violation_date : this.vpat_date ? moment(this.vpat_date).format("YYYY-MM-DD") : null,
            banned_reason : this.banned_reason,
            violations : this.vpat_violations.map(item => item.id),
            company_id : this.company.id
        }
        // var a = 1;
        // if(a == 1){
        //     console.log("object==",object)
        //     this.$commonFuction.is_loading(false);
        //     return;
        // }
        var that = this;
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            await ApiRepository.post("/_api/sra/update_vpat", object, {headers}).then((response) => {
                if (response.status === 200) {
                    that.loadNhanSu();
                } else {
                    that.$toast.add({ 
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: response.data.message,
                        life: 3000
                    });
                    that.$commonFuction.is_loading(false);
                }
            }).catch((err) => {
                console.log(err);
                if(err.response && err.response.data){
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }else{
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }
                
                that.$commonFuction.is_loading(false);
            })
        }
        this.$commonFuction.is_loading(false);
    },
    loadNhanSu(){
        this.listYcNhanSu();
        this.$commonFuction.is_loading(false);
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cấp giấy ra vào thành công', life: 3000 })
        this.showEPDialog = false
        this.showVPATDialog = false
    },
    emitEventVPATViolations(keyword){
        this.$delete(this.vpat_violations_obj.filters, 'keyword')
        if (keyword) {
            this.vpat_violations_obj.filters.keyword = keyword
        }
        this.vpat_violations_obj.offset = 0
        this.getVPATViolations()
    },
    changeOffsetVPATViolations(value){
        this.vpat_violations_obj.offset = value
    },
    async showViolationHistoryDialog(item){
        this.violationHistoryUserName = item.fullname ?? ''
        this.violationHistoryList = []
        this.showViolationHistoryModal = true
        this.violationHistoryLoading = true
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token){
            this.violationHistoryLoading = false
            return
        }
        const headers = {
            "Authorization": "Bearer "+token,
        }
        await ApiRepository.post("/_api/sra/list_violation_history", {
            sra_id : this.view_id,
            sra_users_id : item.id,
            company_id : this.company_id
        }, {headers}).then((response) => {
            let list = response.data.data ?? []
            for (let i = 0; i < list.length; i++) {
                let e = list[i]
                e.violation_date_text = e.violation_date ? moment(e.violation_date).format("DD/MM/YYYY") : ''
            }
            this.violationHistoryList = list
            this.violationHistoryLoading = false
        }).catch(() => {
            this.violationHistoryList = []
            this.violationHistoryLoading = false
        })
    },
    async showIncidentHistoryDialog(item){
        this.incidentHistoryUserName = item.fullname ?? ''
        this.incidentHistoryList = []
        this.showIncidentHistoryModal = true
        this.incidentHistoryLoading = true
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token){
            this.incidentHistoryLoading = false
            return
        }
        const headers = {
            "Authorization": "Bearer "+token,
        }
        await ApiRepository.post("/_api/sra/list_incident_history", {
            sra_id : this.view_id,
            sra_users_id : item.id,
            company_id : this.company_id
        }, {headers}).then((response) => {
            let list = response.data.data ?? []
            for (let i = 0; i < list.length; i++) {
                let e = list[i]
                e.violation_date_text = e.violation_date ? moment(e.violation_date).format("DD/MM/YYYY") : ''
            }
            this.incidentHistoryList = list
            this.incidentHistoryLoading = false
        }).catch(() => {
            this.incidentHistoryList = []
            this.incidentHistoryLoading = false
        })
    },
    removeVPATViolation(index){
        this.vpat_violations.splice(index, 1)
    },
    async getVPATViolations() {
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token){
            return
        }
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.vpat_violations_obj.loading = true
        await ApiRepository.post("/_api/sra_evaluate/options", {
            filters: this.vpat_violations_obj.filters,
            limit: this.vpat_violations_obj.limit,
            offset: this.vpat_violations_obj.offset,
            type: 'violations'
        }, {headers}).then((response) => {
            var list = (response.data.data?.sra_evaluate ?? []).map(item => this.mapEvaluateOption(item))
            if (this.vpat_violations_obj.offset > 0) {
                this.vpat_violations_obj.items.push(...list)
            } else {
                this.vpat_violations_obj.items = list
            }
            this.vpat_violations_obj.total = response.data.data?.count ?? 0
            this.vpat_violations_obj.loading = false
        }).catch(() => {
            this.vpat_violations_obj.loading = false
        })
    },
    showUpdateLessonUsersDialog(item){
        console.log("item==",item)
        var disabled = true
        var showapproved = false
        var users = item.sra_course_lesson_users ? JSON.parse(JSON.stringify(item.sra_course_lesson_users)) : []
        users.map(m=>{
            m.status = m.status ?? null
            m.selStatus = m.status ?? null
            m.course_expired_time = item.course_expired_time
            let expiration_date_show = null
            if(m.expiration_date){
                expiration_date_show = new Date(m.expiration_date)
            }
            m.expiration_date_show = expiration_date_show
        })
        // users = users.concat(users);
        if(this.$store.getters.typeCompany !== 'contractor'){//k phải nhà thầu
            disabled = false
            showapproved = true
        }
        if(item.course_type == 'online'){
            disabled = true
        }
        this.course_lesson = {
            disabled : disabled,
            id : item.id,
            name : item.course_name,
            users : users,
            address : item.address,
            time_text : item.time_text,
            type : item.course_type,
            course_id : item.course_id,
            showapproved : showapproved,
        }
        console.log("this.course_lesson==",this.course_lesson)
        this.showCoureLesson = true
    },
    async approvedKhoaHoc(){
        this.$commonFuction.is_loading(true);
        // this.$commonFuction.is_loading(false);
        console.log("this.course_lesson==",this.course_lesson)
        var tmp = this.course_lesson.users ?? []
        var us = []
        for (let i = 0; i < tmp.length; i++) {
            const e = tmp[i];
            if(e.status !== e.selStatus){
                e.expiration_date = e.expiration_date_show ? moment(e.expiration_date_show).format("YYYY-MM-DD") : null
                us.push(e)
            }
        }
        // console.log("=====",us)
        if(us.length == 0){
            this.$commonFuction.is_loading(false);
            this.showCoureLesson = false
            return;
        }
        var object = {
            course_lesson_id : this.course_lesson.id,
            course_id : this.course_lesson.course_id,
            users : us,
            company_id : this.company.id
        }
        // var aa= 1
        // if(aa == 1){
        //     console.log("object==",object)
        //     this.$commonFuction.is_loading(false);
        //     return
        // }
        var that = this;
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            await ApiRepository.post("/_api/sra/approve_lesson_users", object, {headers}).then((response) => {
                if (response.status === 200) {
                    that.loadKhoaHoc();
                } else {
                    that.$toast.add({ 
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: response.data.message,
                        life: 3000
                    });
                    that.$commonFuction.is_loading(false);
                }
            }).catch((err) => {
                that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: err,
                    life: 3000
                });
                that.$commonFuction.is_loading(false);
            })
        }
        this.$commonFuction.is_loading(false);
    },
    loadKhoaHoc(){
        this.listYcKhoaDaoTao();
        this.$commonFuction.is_loading(false);
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật thành công', life: 3000 })
        this.showCoureLesson = false
    },
    goCapGiayPhep(){
        // alert('đang phát triển');
        var path = '/admin/list-atw/add'
        this.$router.push({path: path , query: {sra_id: this.view_id, company_id: this.company.id}});
    },
    showClose(){
        this.showCloseSRA = true
        return;
    },
    async closeSRA(){
        // console.log("sra_id",this.view_id)
        this.$commonFuction.is_loading(true);
        var object = {
            id : this.view_id,
            company_id : this.company.id
        }
        var that = this;
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            await ApiRepository.post("/_api/sra/close_sra", object, {headers}).then((response) => {
                if (response.status === 200) {
                    that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
                    that.$commonFuction.is_loading(false);
                    that.reloadPage()
                } else {
                    that.$toast.add({ 
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: response.data.message,
                        life: 3000
                    });
                    that.$commonFuction.is_loading(false);
                }
            }).catch((err) => {
                that.$toast.add({
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: err,
                    life: 3000
                });
                that.$commonFuction.is_loading(false);
            })
        }
        this.$commonFuction.is_loading(false);
    },
    async DownloadPDF(item){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(item.download_gp == false){
            return;
        }
        if(token){
            this.$commonFuction.is_loading(true);
            const headers = { "Authorization": "Bearer "+token};
            var {data} = await ApiRepository.post("/_api/sra/su_download_pdf", {sra_users_id: item.id, company_id: this.company.id}, {headers});
            var value = data.data;
            console.log("value=====",value)
            if(value){
                var a = document.createElement('a');
                a.href = value.fileUrl;
                a.download = value.fileName;
                a.target = '_blank';
                // Use a.download if available, it prevents plugins from opening.
                if ('download' in a) {
                    a.download = value.fileName;
                }
                // Add a to the doc for click to work.
                (document.body || document.documentElement).appendChild(a);
                if (a.click) {
                    a.click(); // The click method is supported by most browsers.
                } else {
                    jq(a).click(); // Backup using jquery
                }
                // Delete the temporary link.
                a.parentNode.removeChild(a);
            }
            this.$commonFuction.is_loading(false);
        }
    },
    formatTextToHtml(text){
        if(text){
            return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }
        return '';
    },
    async removeEpAreas(index){
      this.ep_areas.splice(index, 1);
    },
    async emitEventListAdminContractor(keyword){
        this.$delete(this.list_admin_contractor_obj.filters, 'name');
        if (keyword) {
            this.list_admin_contractor_obj.filters.name = keyword;
        }
        this.getListAdminContractor();
    },
    async getListAdminContractor(){
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            this.list_admin_contractor_obj.loading = true;
            await ApiRepository.post("/_api/users/list_by_contractor", {contractor_id : this.contractor_id, company_id: this.company.id, filters: this.list_admin_contractor_obj.filters, limit: this.list_admin_contractor_obj.limit, offset: this.list_admin_contractor_obj.offset, role_company: 'admin'}, {headers}).then((res) => {
                if (this.list_admin_contractor_obj.offset > 0 ) {
                    this.list_admin_contractor_obj.items.push(...res.data.data.list);
                } else{
                    this.list_admin_contractor_obj.items = res.data.data.list;
                }
                this.list_admin_contractor_obj.total = res.data.data.count;
                this.list_admin_contractor_obj.loading = false;
            }).catch((err) => {
                console.log(err);
                this.list_admin_contractor_obj.loading = false;
            })
        }
    },
    async removeListAdminContractor(index){
        this.list_admin_contractor.splice(index, 1);
    },
    async GuiNhaThau(){
        // console.log("gửi nhà thầu")
        this.$commonFuction.is_loading(true);
        this.list_admin_contractor_sel = null
        this.list_admin_contractor = []
        this.subject_text = this.name
        await this.getListAdminContractorDefault()
        this.showGuiNhaThau = true
        this.$commonFuction.is_loading(false);
    },
    async getListAdminContractorDefault(){
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            this.list_admin_contractor_obj.loading = true;
            await ApiRepository.post("/_api/users/list_by_contractor", {contractor_id : this.contractor_id, company_id: this.company.id, filters: this.list_admin_contractor_obj.filters, limit: this.list_admin_contractor_obj.limit, offset: this.list_admin_contractor_obj.offset, role_company: 'admin'}, {headers}).then((res) => {
                var tmp_list_admin_contractor = res.data.data.list
                var content_text = '<p><strong>Kính gửi:&nbsp;</strong>'
                for (let i = 0; i < tmp_list_admin_contractor.length; i++) {
                    const e = tmp_list_admin_contractor[i];
                    if(i > 0){
                        content_text+= `, ${e.fullname}`
                    }else{
                        content_text+= e.fullname
                    }
                }
                content_text+= '</p>'
                content_text+= `<p>SRA số ${this.name} có sự thay đổi thông tin</p>`
                // console.log("222222222222")
                this.list_admin_contractor = tmp_list_admin_contractor
                this.content_text = content_text
            }).catch((err) => {
                console.log(err);
            })
        }
    },
    handleEnter(){
      if(this.tag_text){
        if(this.isEmail(this.tag_text)){
          if(!this.tags_show.includes(this.tag_text)){
            this.tags_show.push(this.tag_text)
            this.tag_text = ''
          }else{
            alert(`Email "`+this.tag_text+`" đã tồn tại`);
          }
        }else{
          alert(`Email "`+this.tag_text+`" không hợp lệ`);
        }
      }
    },
    isEmail(email) {
      var re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(email);
    },
    removeTagsShow(index){
      this.tags_show.splice(index, 1)
    },
    async emitEventListAdminCompany(keyword){
        this.$delete(this.list_admin_company_obj.filters, 'name');
        if (keyword) {
            this.list_admin_company_obj.filters.name = keyword;
        }
        this.getListAdminCompany();
    },
    async getListAdminCompany(){
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            this.list_admin_company_obj.loading = true;
            await ApiRepository.post("/_api/users/list_by_company", {company_id: this.company.id, filters: this.list_admin_company_obj.filters, limit: this.list_admin_company_obj.limit, offset: this.list_admin_company_obj.offset, role_company: 'admin'}, {headers}).then((res) => {
                if (this.list_admin_company_obj.offset > 0 ) {
                    this.list_admin_company_obj.items.push(...res.data.data.list);
                } else{
                    this.list_admin_company_obj.items = res.data.data.list;
                }
                this.list_admin_company_obj.total = res.data.data.count;
                this.list_admin_company_obj.loading = false;
            }).catch((err) => {
                console.log(err);
                this.list_admin_company_obj.loading = false;
            })
        }
    },
    async SendEmailNT(){
        this.$commonFuction.is_loading(true);
        // console.log("Gọi API gửi email")
        // console.log("this.tags_show==",this.tags_show)
        // console.log("this.list_admin_contractor==",this.list_admin_contractor)
        // console.log("this.subject_text==",this.subject_text)
        // console.log("this.content_text==",this.content_text)
        //lấy danh sách email cần gửi
        if(this.$commonFuction.isEmpty(this.subject_text) || this.$commonFuction.isEmpty(this.content_text)){
            alert("Vui lòng nhập đầy đủ subject và nội dung.")
            this.$commonFuction.is_loading(false);
            return;
        }
        var list_email = []
        for (let i = 0; i < this.list_admin_contractor.length; i++) {
            const e = this.list_admin_contractor[i];
            if(e.email && !list_email.includes(e.email)){
                list_email.push(e.email)
            }
        }
        for (let i = 0; i < this.tags_show.length; i++) {
            const mail = this.tags_show[i];
            if(mail && !list_email.includes(mail)){
                list_email.push(mail)
            }
        }
        // console.log("list_email==",list_email)
        if(list_email.length == 0){
            alert("Vui lòng chọn admin nhà thầu hoặc đối tượng nhận email khác.")
            this.$commonFuction.is_loading(false);
            return;
        }
        await ApiRepository.post("/_api/common/send_email", {subject : this.subject_text, content : this.content_text, emails : list_email, sra_id : this.view_id, company_id: this.company.id, type_data : 'send_to_contractor'}, {}).then(() => {
            alert("Đã gửi thành công")
            this.showGuiNhaThau = false
        }).catch((err) => {
            console.log(err);
            alert("Gửi thất bại")
        })
        this.$commonFuction.is_loading(false);
    },
    async GuiChuDauTu(){
        // console.log("gửi chủ đầu tư")
        this.$commonFuction.is_loading(true);
        this.list_admin_company_sel = null
        this.list_admin_company = []
        this.sra_related_user_sel = null
        this.sra_related_users = []
        this.sra_related_user_obj.items = []
        this.sra_related_user_obj.total = 0
        this.subject_text = this.name
        if(this.company_type == 'option_1'){
            this.company_info = {}
            await this.getSraRelatedUsers(true)
        }else{
            await this.getInfoCompany()
            await this.getInfoCompanyDefault()
        }
        // console.log("this.company_info======",this.company_info)
        this.showGuiChuDauTu = true
        this.$commonFuction.is_loading(false);
    },
    getSraRelatedUserIds(){
        var user_ids = [this.model?.created_by, this.model?.uid_c1, this.model?.uid_c2]
        if(this.model?.sra_supervisor && this.model.sra_supervisor.length > 0){
            this.model.sra_supervisor.forEach(item => user_ids.push(item.uid ?? item.id))
        }
        return [...new Set(user_ids.filter(id => id))]
    },
    async emitEventSraRelatedUsers(keyword){
        this.$delete(this.sra_related_user_obj.filters, 'name')
        if(keyword){
            this.sra_related_user_obj.filters.name = keyword
        }
        this.sra_related_user_obj.offset = 0
        await this.getSraRelatedUsers(false)
    },
    async getSraRelatedUsers(select_all = false){
        var user_ids = this.getSraRelatedUserIds()
        if(user_ids.length == 0){
            this.content_text = `<p><strong>Kính gửi:&nbsp;</strong></p><p>SRA số ${this.name} có sự thay đổi thông tin</p>`
            return
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token){
            return
        }
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.sra_related_user_obj.loading = true
        await ApiRepository.post("/_api/users/list_sra_related_users", {
            user_ids: user_ids,
            filters: this.sra_related_user_obj.filters
        }, {headers}).then((res) => {
            var users = res.data.data.list ?? []
            this.sra_related_user_obj.items = users
            this.sra_related_user_obj.total = res.data.data.count ?? 0
            if(select_all){
                this.sra_related_users = [...users]
                this.updateSraRelatedContent()
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            this.sra_related_user_obj.loading = false
        })
    },
    updateSraRelatedContent(){
        if(this.company_type != 'option_1'){
            return
        }
        var recipients = [...this.list_admin_company, ...this.sra_related_users]
        var recipient_names = []
        var recipient_ids = []
        recipients.forEach(item => {
            var recipient_key = item.id ?? item.email ?? item.fullname
            if(item.fullname && !recipient_ids.includes(recipient_key)){
                recipient_ids.push(recipient_key)
                recipient_names.push(item.fullname)
            }
        })
        var related_names = recipient_names.join(', ')
        this.content_text = `<p><strong>Kính gửi:&nbsp;</strong>${related_names}</p><p>SRA số ${this.name} có sự thay đổi thông tin</p>`
    },
    async removeSraRelatedUser(index){
        this.sra_related_users.splice(index, 1)
        this.updateSraRelatedContent()
    },
    async getInfoCompanyDefault(){
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            this.list_admin_company_obj.loading = true;
            await ApiRepository.post("/_api/users/list_by_company", {company_id: this.company.id, filters: this.list_admin_company_obj.filters, limit: this.list_admin_company_obj.limit, offset: this.list_admin_company_obj.offset, role_company: 'admin'}, {headers}).then((res) => {
                var tmp_list_admin_company = res.data.data.list
                var content_text = '<p><strong>Kính gửi:&nbsp;</strong>'
                for (let i = 0; i < tmp_list_admin_company.length; i++) {
                    const e = tmp_list_admin_company[i];
                    if(i > 0){
                        content_text+= `, ${e.fullname}`
                    }else{
                        content_text+= e.fullname
                    }
                }
                content_text+= '</p>'
                content_text+= `<p>SRA số ${this.name} có sự thay đổi thông tin</p>`
                // console.log("222222222222")
                // this.list_admin_company = tmp_list_admin_company
                this.content_text = content_text
            }).catch((err) => {
                console.log(err);
            })
        }
    },
    async SendEmailCDT(){     
        this.$commonFuction.is_loading(true);
        // console.log("Gọi API gửi email Chủ đầu tư")
        // console.log("this.tags_show==",this.tags_show)
        // console.log("this.list_admin_company==",this.list_admin_company)
        // console.log("this.subject_text==",this.subject_text)
        // console.log("this.content_text==",this.content_text)
        //lấy danh sách email cần gửi
        if(this.$commonFuction.isEmpty(this.subject_text) || this.$commonFuction.isEmpty(this.content_text)){
            alert("Vui lòng nhập đầy đủ subject và nội dung.")
            this.$commonFuction.is_loading(false);
            return;
        }
        var list_email = []
        for (let i = 0; i < this.list_admin_company.length; i++) {
            const e = this.list_admin_company[i];
            if(e.email && !list_email.includes(e.email)){
                list_email.push(e.email)
            }
        }
        if(this.company_type == 'option_1'){
            for (let i = 0; i < this.sra_related_users.length; i++) {
                const user = this.sra_related_users[i]
                if(user.email && !list_email.includes(user.email)){
                    list_email.push(user.email)
                }
            }
        }
        // for (let i = 0; i < this.tags_show.length; i++) {
        //     const mail = this.tags_show[i];
        //     if(mail && !list_email.includes(mail)){
        //         list_email.push(mail)
        //     }
        // }
        // console.log("list_email==",list_email)
        if(list_email.length == 0 && this.company_type != 'option_1'){
            if(!this.$commonFuction.isEmpty(this.company_info)){
                if(!this.$commonFuction.isEmpty(this.company_info.email)){
                    list_email.push(this.company_info.email)
                }
            }else{
                alert("Vui lòng chọn ít nhất một công ty hoặc chủ đầu tư.")
                this.$commonFuction.is_loading(false);
                return;
            }
            
        }else if(list_email.length == 0){
            alert("Vui lòng chọn ít nhất một người liên quan đến SRA hoặc chủ đầu tư.")
            this.$commonFuction.is_loading(false);
            return;
        }
        await ApiRepository.post("/_api/common/send_email", {subject : this.subject_text, content : this.content_text, emails : list_email, sra_id : this.view_id, company_id: this.company.id, type_data : 'send_to_company'}, {}).then(() => {
            alert("Đã gửi thành công")
            this.showGuiChuDauTu = false
        }).catch((err) => {
            console.log(err);
            alert("Gửi thất bại")
        })
        this.$commonFuction.is_loading(false);
    },
    async removeListAdminCompany(index){
        this.list_admin_company.splice(index, 1);
        if(this.company_type == 'option_1'){
            this.updateSraRelatedContent()
        }
    },
    async getInfoCompany() {
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            await ApiRepository.post("/_api/company/detail", {company_id: this.company.id}, {headers}).then((res) => {
                var company = res.data.data;
                var company_info = {
                    id : company.id,
                    name : company.name,
                    email : company.user?.email,
                }
                // console.log("company_info===",company_info)
                this.company_obj.items = [company_info]
                this.company_obj.total = 1
                this.company_info = company_info
            }).catch((err) => {
                console.log(err);
            })
        }
        
    },
    goEvaluate(){
      this.$router.push({ path: '/admin/list-sra/details/'+this.view_id, query: {company_id: this.company_id} });
    },
    async onFileSelect2(event) {
      let files = event.target.files || event.dataTransfer.files;
      this.loading_here = true;
      if (files.length > 0) {
        if (files.length > this.maxFilesProfile) {
          event.target.value = "";
          alert("Chỉ được upload tối đa "+this.maxFilesProfile+" file");
          this.loading_here = false;
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
          "png", "jpg", "jpeg", "PNG", "JPG", "JPEG",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert(
              "Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg."
            );
            this.loading_here = false;
            return;
          }
        }
        if (files.length + this.info_course.files.length > this.maxFilesProfile) {
          event.target.value = "";
          alert("Số lượng tối đa là " + this.maxFilesProfile + " files");
          this.loading_here = false;
          return;
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            console.log(file.type);
            // this.isImage(file){
              if (file.size <= this.maxFileSize) {
                file.source = file;
                file.objectURL = window.URL.createObjectURL(file);
                file.is_new = true;
                arrTemp.push(file);
              }else{
                arrFiles.push(file);
              }
            // }
          }
          // console.log("arrTemp",arrTemp)
          if (arrFiles.length > 0) {
            event.target.value = "";
            alert("File của bạn đã quá dung lượng 50MB");
            this.loading_here = false;
            return;
          } else {
            // this.files = this.files.concat.apply(this.files, arrTemp);
            console.log("arrTemp===",arrTemp);
            var tmp_add = []
            await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.DOCUMENT_FILES, arrTemp).then((resImage)=> {
              tmp_add = resImage
            })
            this.info_course.files = this.info_course.files.concat.apply(this.info_course.files, tmp_add);
          }
        }
      }
      // console.log("this.info_course",this.info_course)
      event.target.value = "";
      this.loading_here = false;
      return;
    },
    async onFileDownload(index) {
      let file = this.info_course.files[index];
      window.open(file.url);
    },
    async onFileDownload1(index) {
      let file = this.files_evaluate[index]
      window.open(file.url ?? file.objectURL)
    },
    async onFileDownloadControlMeasures(index) {
      let file = this.files_control_measures[index]
      window.open(file.url ?? file.objectURL)
    },
    showAddControlMeasuresFile(){
      this.control_measures_files_dialog = []
      this.showAddControlMeasuresFileDialog = true
    },
    onFileDownloadControlMeasuresDialog(index) {
      let file = this.control_measures_files_dialog[index]
      window.open(file.url ?? file.objectURL)
    },
    onFileClearControlMeasures(index) {
      this.control_measures_files_dialog.splice(index, 1)
    },
    async onFileSelectControlMeasures(event) {
      let files = event.target.files || event.dataTransfer.files;
      this.cm_file_loading = true;
      if (files.length > 0) {
        if (files.length > this.maxFiles) {
          event.target.value = "";
          alert("Chỉ được upload tối đa "+this.maxFiles+" file");
          this.cm_file_loading = false;
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
          "png", "jpg", "jpeg", "PNG", "JPG", "JPEG",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert("Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.");
            this.cm_file_loading = false;
            return;
          }
        }
        if (files.length + this.control_measures_files_dialog.length > this.maxFiles) {
          event.target.value = "";
          alert("Số lượng tối đa là " + this.maxFiles + " files");
          this.cm_file_loading = false;
          return;
        } else {
          var arrTemp = [], arrFiles = [];
          for (let file of files) {
            if (file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              file.is_new = true;
              arrTemp.push(file);
            } else {
              arrFiles.push(file);
            }
          }
          if (arrFiles.length > 0) {
            event.target.value = "";
            alert("File của bạn đã quá dung lượng 50MB");
            this.cm_file_loading = false;
            return;
          } else {
            var tmp_add = []
            await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.CONTROL_MEASURES, arrTemp).then((resImage)=> {
              tmp_add = resImage
            })
            this.control_measures_files_dialog = this.control_measures_files_dialog.concat.apply(this.control_measures_files_dialog, tmp_add);
          }
        }
      }
      event.target.value = "";
      this.cm_file_loading = false;
    },
    async saveControlMeasuresFile() {
      this.$commonFuction.is_loading(true);
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = { "Authorization": "Bearer "+token };
        var files_new = this.control_measures_files_dialog
          .map(item => ({id: item.id, name: item.name, url: item.url}))
        var params = {
          id: this.view_id,
          files_new: files_new,
        }
        await ApiRepository.post("/_api/sra/update_control_measures_file", params, {headers}).then((res) => {
          this.files_control_measures = res.data.data?.files ?? []
          this.showAddControlMeasuresFileDialog = false
          this.control_measures_files_dialog = []
          this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu file đính kèm thành công', life: 3000 })
        }).catch((err) => {
          console.log(err);
          this.$toast.add({ severity: 'error', summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG, detail: err, life: 3000 })
        })
      }
      this.$commonFuction.is_loading(false);
    },
    async onFileDownloadWorkPermit(index) {
      let file = this.files_work_permit[index]
      window.open(file.url ?? file.objectURL)
    },
    showAddWorkPermitFile(){
      this.work_permit_files_dialog = []
      this.showAddWorkPermitFileDialog = true
    },
    onFileDownloadWorkPermitDialog(index) {
      let file = this.work_permit_files_dialog[index]
      window.open(file.url ?? file.objectURL)
    },
    onFileClearWorkPermit(index) {
      this.work_permit_files_dialog.splice(index, 1)
    },
    async onFileSelectWorkPermit(event) {
      let files = event.target.files || event.dataTransfer.files;
      this.wp_file_loading = true;
      if (files.length > 0) {
        if (files.length > this.maxFiles) {
          event.target.value = "";
          alert("Chỉ được upload tối đa "+this.maxFiles+" file");
          this.wp_file_loading = false;
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
          "png", "jpg", "jpeg", "PNG", "JPG", "JPEG",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert("Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.");
            this.wp_file_loading = false;
            return;
          }
        }
        if (files.length + this.work_permit_files_dialog.length > this.maxFiles) {
          event.target.value = "";
          alert("Số lượng tối đa là " + this.maxFiles + " files");
          this.wp_file_loading = false;
          return;
        } else {
          var arrTemp = [], arrFiles = [];
          for (let file of files) {
            if (file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              file.is_new = true;
              arrTemp.push(file);
            } else {
              arrFiles.push(file);
            }
          }
          if (arrFiles.length > 0) {
            event.target.value = "";
            alert("File của bạn đã quá dung lượng 50MB");
            this.wp_file_loading = false;
            return;
          } else {
            var tmp_add = []
            await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.WORK_PERMIT, arrTemp).then((resImage)=> {
              tmp_add = resImage
            })
            this.work_permit_files_dialog = this.work_permit_files_dialog.concat.apply(this.work_permit_files_dialog, tmp_add);
          }
        }
      }
      event.target.value = "";
      this.wp_file_loading = false;
    },
    async saveWorkPermitFile() {
      this.$commonFuction.is_loading(true);
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = { "Authorization": "Bearer "+token };
        var files_new = this.work_permit_files_dialog
          .map(item => ({id: item.id, name: item.name, url: item.url}))
        var params = {
          id: this.view_id,
          files_new: files_new,
        }
        await ApiRepository.post("/_api/sra/update_work_permit_file", params, {headers}).then((res) => {
          this.files_work_permit = res.data.data?.files ?? []
          this.showAddWorkPermitFileDialog = false
          this.work_permit_files_dialog = []
          this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu file đính kèm thành công', life: 3000 })
        }).catch((err) => {
          console.log(err);
          this.$toast.add({ severity: 'error', summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG, detail: err, life: 3000 })
        })
      }
      this.$commonFuction.is_loading(false);
    },
    onFileClear2(index) {
      let file = this.info_course.files[index];
      this.info_course.files.splice(index, 1);
      if (file && file.is_old==true) this.filesDeletes2_tmp.push(file.id);
    },
    async openFile(file) {
      try {
        const response = await fetch(file.url, { mode: "cors" }); // url từ server
        if (!response.ok) throw new Error("Không tải được file");

        console.log("response", response);

        const blob = await response.blob();

        let mimeType = blob.type;
        if (mimeType === "application/octet-stream") {
          const ext = file.name.split(".").pop().toLowerCase();
          if (["jpg", "jpeg", "png"].includes(ext)) {
            mimeType = "image/jpeg";
          } else if (ext === "pdf") {
            mimeType = "application/pdf";
          }
        }
        console.log("mimeType", mimeType);

        const fixedBlob = new File([blob], file.name, { type: mimeType });
        const objectURL = URL.createObjectURL(fixedBlob);
        
        // nếu là PDF hoặc ảnh thì mở online trong tab mới
        if (mimeType.includes("pdf") || mimeType.includes("image")) {
          window.open(objectURL, "_blank"); // giờ sẽ hiển thị online
        } else {
          const link = document.createElement("a");
          link.href = objectURL;
          link.download = file.name || file.url.split("/").pop();
          link.click();
        }

      } catch (err) {
        console.error("Không mở được file:", err);
        alert("Không mở được file");
      }
    },
    formatDateFile(dateString='') {
      var string = ''
      if(dateString){
        string = moment(dateString).format("DD/MM/YYYY HH:mm:ss");
      }
      return string;
    },
    onStatusChange(item,){
    //   console.log("onStatusChange",item)
      if(item.selStatus == 'PASS'){
        var expiration_date = item.expiration_date ?? null
        var expired_time = item.course_expired_time ?? 0
        var new_date = new Date()
        var new_date_show = null
        if(expiration_date){
          var old_data = new Date(expiration_date)
          if(old_data > new_date){
            new_date_show = old_data;
          }
        }else{
          new_date_show = new_date;
          //cộng thêm 10 tháng
          new_date_show.setMonth(new_date_show.getMonth() + expired_time);
        }
        // console.log("new_date_show",new_date_show)
        item.expiration_date_show = new_date_show
      }
    },
    async updateStatusWork() {
        this.$commonFuction.is_loading(true);
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                Authorization: `Bearer ${token}`
            };
            var object = {
                id : this.view_id,
                status_work : this.status_work?.value ?? null,
                company_id : this.company.id
            }
            await ApiRepository.post("/_api/sra/update_status_work", object, {headers}).then((response) => {
                if (response.status === 200) {
                    this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật trạng thái công việc thành công', life: 3000 })
                    // this.reloadPage()
                } else {
                    this.$toast.add({ 
                        severity: 'error',
                        summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: response.data.message,
                        life: 3000
                    });
                }
            }).catch((err) => {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: err,
                    life: 3000
                });
            })
        }
        this.$commonFuction.is_loading(false);
    },
    async SuCoAnToan(){
        this.select_nscheck = []
        this.scat_violations = []
        this.scat_date = new Date()
        this.scat_violations_sel = null
        this.scat_violations_obj.offset = 0
        this.scat_violations_obj.filters = {}
        this.scat_violations_obj.items = []
        this.scat_violations_obj.total = 0
        this.ep_fullname = ''
        var ep_fullname = ''
        for (let i = 0; i < this.list_tab_yc_nhansu.length; i++) {
            let e = this.list_tab_yc_nhansu[i]
            if(e.active_check == true){
                this.select_nscheck.push({
                    id : e.uid,
                    fullname : e.fullname,
                    sra_users_id : e.id
                })
                if(ep_fullname == ''){
                    ep_fullname = e.fullname
                }else if(ep_fullname != ''){
                    ep_fullname += '; '+e.fullname
                }
            }
        }
        if(this.select_nscheck.length == 0){
            alert('Vui lòng chọn nhân sự vi phạm loại TNLD/sự cố an toàn.');
            return;
        }
        this.ep_fullname = ep_fullname
        await this.getSCATViolations()
        this.showSCATDialog = true
    },
    emitEventSCATViolations(keyword){
        this.$delete(this.scat_violations_obj.filters, 'keyword')
        if (keyword) {
            this.scat_violations_obj.filters.keyword = keyword
        }
        this.scat_violations_obj.offset = 0
        this.getSCATViolations()
    },
    changeOffsetSCATViolations(value){
        this.scat_violations_obj.offset = value
    },
    removeSCATViolation(index){
        this.scat_violations.splice(index, 1)
    },
    async getSCATViolations() {
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(!token){
            return
        }
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.scat_violations_obj.loading = true
        await ApiRepository.post("/_api/sra_evaluate/options", {
            filters: this.scat_violations_obj.filters,
            limit: this.scat_violations_obj.limit,
            offset: this.scat_violations_obj.offset,
            type: 'incidents'
        }, {headers}).then((response) => {
            var list = (response.data.data?.sra_evaluate ?? []).map(item => this.mapEvaluateOption(item))
            if (this.scat_violations_obj.offset > 0) {
                this.scat_violations_obj.items.push(...list)
            } else {
                this.scat_violations_obj.items = list
            }
            this.scat_violations_obj.total = response.data.data?.count ?? 0
            this.scat_violations_obj.loading = false
        }).catch(() => {
            this.scat_violations_obj.loading = false
        })
    },
    async approvedSCAT(){
        if(this.scat_violations.length == 0){
            alert('Vui lòng chọn loại TNLĐ/sự cố an toàn.');
            return;
        }
        if (this.$commonFuction.isEmptyObject(this.company)) {
            return;
        }
        this.$commonFuction.is_loading(true);
        var incident_reason = this.scat_violations.map(item => item.label).join('; ')
        var object ={
            id : this.view_id,
            users : this.select_nscheck,
            incident_date : this.scat_date ? moment(this.scat_date).format("YYYY-MM-DD") : null,
            incident_reason : incident_reason,
            incidents : this.scat_violations.map(item => item.id),
            company_id : this.company.id
        }
        var that = this;
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            };
            await ApiRepository.post("/_api/sra/update_scat", object, {headers}).then((response) => {
                if (response.status === 200) {
                    that.loadSCAT();
                } else {
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: response.data.message,
                        life: 3000
                    });
                    that.$commonFuction.is_loading(false);
                }
            }).catch((err) => {
                console.log(err);
                if(err.response && err.response.data){
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }else{
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }

                that.$commonFuction.is_loading(false);
            })
        }
        this.$commonFuction.is_loading(false);
    },
    loadSCAT(){
        this.listYcNhanSu();
        this.$commonFuction.is_loading(false);
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật thành công', life: 3000 })
        this.showSCATDialog = false
    },
  }

  
}
</script>
<style lang="scss">
  .btn-add-control-measures-file {
    max-width: 100px;
  }
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    font-weight: 700;
  }
    .tab {
        display: flex;
        font-weight: 700;
        border-bottom: 1px solid #00000029;
    }
    .tab div {
        padding: 6px 8px;
        /* margin-right: 2px; */
        cursor: pointer;
    }
    .tab div.active {
        background-color: #fff;
        color: #0086C4;
        border-left: 1px solid #0086C4;
        border-right: 1px solid #0086C4;
        border-bottom: 3px solid #0086C4;
        border-top: 1px solid #0086C4;
    }
    .content {
        padding-top: 10px;
        display: none;
    }
    .content.active {
        display: block;
    }
    .button-container {
        display: flex;
        justify-content: flex-end; /* Căn chỉnh các nút về bên phải */
    }
    .button-container button {
        width: auto !important;
        margin-left: 5px; /* Khoảng cách giữa các nút */
    }
    .p-button-disa {
        color : #666666;
        background-color : #F2F3F7;
        border: 1px solid #F2F3F7;
    }
    .p-button-disa:hover {
        background-color: #F2F3F7 !important;
        border: 1px solid #F2F3F7 !important;
        color : #666666 !important;
    }
    .row-cs {
        padding-top : 6px;
    }
    .f-cus {
        color : #0086C4;
        font-weight: 700;
        font-size: 18px;
    }
    .title-css { 
  font-weight: bold;
}
.drop-cus {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
}
.accordion-item {
  border: 1px solid #ddd;
  border-radius: 5px;
}
.accordion-label {
  display: block;
  padding: 8px;
  background-color: #DFE2E6;
  /* font-size: 15px; */
  font-weight: bold;
  cursor: pointer;
}
.accordion-content {
  margin-bottom: 5px;
}
.f-grid-v {
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  padding: 5px;
}
.f-grid-col-v {
  flex: 1 0;
  background-color: #F8F9FB;
  padding: 0px 10px 10px 10px;
  border-radius: 5px;
  margin: 5px 5px 5px 5px;
}
.left-cs {
    text-align: left;
    font-weight: bold;
    width: 120px;
}
.right-cs {
    text-align: right;
}
.left-cs-2 {
    text-align: left;
    font-weight: bold;
    width: 130px;
    min-width: 130px;
}
.container-tpl {
    display: flex; /* Sử dụng Flexbox để chia thành 2 phần */
    justify-content: space-between; /* Căn chỉnh nội dung sang hai bên */
    /* align-items: center; */
    padding-top : 5px;
}
.titel-cs {
    font-weight: bold;
}
.f-grid-col-v2 {
  background-color: #F8F9FB;
  padding: 0px 10px 5px 10px;
  border-radius: 5px;
  margin: 
  5px 10px 5px 10px;
}
.container-tpl-v2 {
    padding-top : 0px;
}
#yc_nhathau {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#yc_nhathau td {
  border: 1px solid #ddd;
  padding: 5px 8px 5px 8px;
  width: 20%;
  vertical-align: top;
}
#yc_nhathau th {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  width: 20%;
}
#yc_nhathau th {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left !important;
  background-color: #F4F4F4;
}
.pad-cus {
    padding-top: 2px;
    padding-bottom: 2px;
}
.container-tpl-vt {
    display: flex;
}
.cl-other {
    min-width: 37px;
}

#yc_nhathau_tab {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#yc_nhathau_tab td {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
  /* vertical-align: top; */
}
#yc_nhathau_tab th {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
}
#yc_nhathau_tab th {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left !important;
  background-color: #F4F4F4;
}
.download-file-cs {
  color : #0086C4;
  text-decoration: underline;
  cursor: pointer;
}
.profile-file-list {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.profile-file-row {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 4px;
}
.profile-file-link {
  display: block;
  max-width: 100%;
  color: #0086C4;
  text-align: left;
  text-decoration: underline;
  overflow-wrap: anywhere;
  cursor: pointer;
}
.table-scroll-x {
  cursor: grab;
  overflow-x: auto;
}
.scroll-top-bar {
  overflow-x: auto;
  overflow-y: hidden;
}
.table-scroll-x.dragging {
  cursor: grabbing;
  user-select: none;
}
.text-inactive-user {
  color: #9e9e9e;
}
#yc_nhansu_tab {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#yc_nhansu_tab td {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
  /* vertical-align: top; */
}
#yc_nhansu_tab th {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
}
#yc_nhansu_tab th {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left !important;
  background-color: #F4F4F4;
}
#kdt_tab {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#kdt_tab td {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
  /* vertical-align: top; */
}
#kdt_tab th {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
}
#kdt_tab th {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left !important;
  background-color: #F4F4F4;
}
#yc_vattu_thietbi_tab {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#yc_vattu_thietbi_tab td {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
  /* vertical-align: top; */
}
#yc_vattu_thietbi_tab th {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
}
#yc_vattu_thietbi_tab th {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left !important;
  background-color: #F4F4F4;
}

.status-approved {
  color: #00973C;
  font-weight: bold;
}
.status-rejected {
  color: #F5564E;
  font-weight: bold;
}
.span-link{
    color: #0086C4;
    cursor: pointer;
}
#dialog_table {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 500px;
}

#dialog_table td {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 30px;
  /* vertical-align: top; */
}
#dialog_table th {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 30px;
}
#dialog_table th {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left !important;
  background-color: #F4F4F4;
}
.css-underline {
    text-decoration: underline;
}
.p-button-download-sra {
    background-color: #537BC4;
    border-color: #537BC4;
}
.p-button-download-sra:hover {
    background-color: #537BC4 !important;
    border-color: #537BC4 !important;
}
.hide-tab {
    display: none;
}
.cus-tags{
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#F2F3F7;
}
.cs-tag {
  padding: 10px 12px 10px 0px;
  font-weight: normal;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}
.evaluation-view {
  padding-top: 8px;
}
.evaluation-title {
  font-weight: 700;
}
.evaluation-label {
  font-weight: 700;
}
.readonly-box {
  flex-wrap: wrap;
}
.readonly-box button {
  cursor: default;
}
.readonly-box button:disabled {
  opacity: 1;
}
.evaluation-note {
  min-height: 42px;
  padding: 8px 10px;
  white-space: pre-wrap;
  word-break: break-word;
  background: #F8F9FB;
}
.evaluation-tags {
  min-height: 42px;
  padding: 8px 10px;
  background: #F8F9FB;
}
.evaluation-empty {
  color: #666666;
}
.evaluation-empty-state {
  margin-top: 12px;
  color: #666666;
  font-style: italic;
}
.btn-group-css {
  display: flex;
}
.btn-switch {
  width: 100px;
  padding: 8px;
  border: 1px solid #ccc;
  background-color: #fff;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s ease, color 0.3s ease;
  text-align: center;
  white-space: nowrap;
}
.btn-switch:hover {
  background-color: #aabcff;
}
.btn-switch.selected {
  background-color: #0086C4;
  color: white;
}
.btn-switch-1 {
  width: 140px;
  padding: 8px;
  border: 1px solid #ccc;
  background-color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  text-align: center;
  white-space: nowrap;
  font-size: 20px;
}
.btn-switch-1:hover {
  background-color: #aabcff;
}
.btn-switch-1.selected {
  background-color: green;
  color: white;
}
.btn-switch-2 {
  width: 140px;
  padding: 8px;
  border: 1px solid #ccc;
  background-color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  text-align: center;
  white-space: nowrap;
  font-size: 20px;
}
.btn-switch-2:hover {
  background-color: #aabcff;
}
.btn-switch-2.selected {
  background-color: orange;
  color: white;
}
.btn-switch-3 {
  width: 140px;
  padding: 8px;
  border: 1px solid #ccc;
  background-color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  text-align: center;
  white-space: nowrap;
  font-size: 20px;
}
.btn-switch-3:hover {
  background-color: #aabcff;
}
.btn-switch-3.selected {
  background-color: red;
  color: white;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 5px solid #ccc;
  border-top: 5px solid #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

.risk-cs-l-1 {
  background-color: yellow;
  border-radius: 5px;
  /* color: white; */
}
.risk-cs-m-1 {
  background-color: orange;
  border-radius: 5px;
  color: white;
}
.risk-cs-h-1 {
  background-color: red;
  border-radius: 5px;
  color: white;
}

.risk-span {
    padding: 2px 4px 2px 4px;
}

#diemdanh_tab {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#diemdanh_tab td {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
  /* vertical-align: top; */
}
#diemdanh_tab th {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
}
#diemdanh_tab th {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left !important;
  background-color: #F4F4F4;
}
#attendance_dialog_tab {
  border-collapse: collapse;
  width: 100%;
}

#attendance_dialog_tab td {
  border: 1px solid #ddd;
  padding: 8px;
  vertical-align: top;
}

#attendance_dialog_tab th {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left !important;
  background-color: #F4F4F4;
}

.p-paginator-bottom {
  padding: 0 !important;
}

.attendance-hours-input,
.attendance-hours-input.p-inputwrapper,
.attendance-hours-input .p-inputnumber,
.attendance-hours-input .p-inputtext {
  width: 100%;
  display: block;
}
.cus-tags-1 {
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#0086C4;
}
.cs-tag-1 {
  padding: 10px 12px 10px 0px;
  font-weight: normal;
  color: white;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>












